var _regeneratorRuntime = require("/home/runner/work/react-laag/react-laag/node_modules/@babel/runtime/regenerator");

var _inherits = require("/home/runner/work/react-laag/react-laag/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/react-laag/react-laag/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/react-laag/react-laag/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _defineProperty = require("/home/runner/work/react-laag/react-laag/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/runner/work/react-laag/react-laag/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/home/runner/work/react-laag/react-laag/node_modules/@babel/runtime/helpers/toConsumableArray");

var _taggedTemplateLiteral = require("/home/runner/work/react-laag/react-laag/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _classCallCheck = require("/home/runner/work/react-laag/react-laag/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/react-laag/react-laag/node_modules/@babel/runtime/helpers/createClass");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e21) { throw _e21; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e22) { didErr = true; err = _e22; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.object.from-entries.js");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).prettierPlugins = e.prettierPlugins || {}, e.prettierPlugins.angular = t());
}(this, function () {
  "use strict";

  var e = function e(_e2) {
    return "string" == typeof _e2 ? _e2.replace(function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$onlyFirst = _ref.onlyFirst,
          e = _ref$onlyFirst === void 0 ? !1 : _ref$onlyFirst;

      var t = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:[a-zA-Z\\d]*(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
      return new RegExp(t, e ? void 0 : "g");
    }(), "") : _e2;
  };

  var t = function t(e) {
    return !Number.isNaN(e) && e >= 4352 && (e <= 4447 || 9001 === e || 9002 === e || 11904 <= e && e <= 12871 && 12351 !== e || 12880 <= e && e <= 19903 || 19968 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510 || 110592 <= e && e <= 110593 || 127488 <= e && e <= 127569 || 131072 <= e && e <= 262141);
  };

  var r = t,
      n = t;
  r.default = n;

  var i = function i(t) {
    if ("string" != typeof t || 0 === t.length) return 0;
    if (0 === (t = e(t)).length) return 0;
    t = t.replace(/\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g, "  ");
    var n = 0;

    for (var _e3 = 0; _e3 < t.length; _e3++) {
      var _i = t.codePointAt(_e3);

      _i <= 31 || _i >= 127 && _i <= 159 || _i >= 768 && _i <= 879 || (_i > 65535 && _e3++, n += r(_i) ? 2 : 1);
    }

    return n;
  };

  var s = i,
      u = i;
  s.default = u;

  var a = function a(e) {
    if ("string" != typeof e) throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  };

  var o = function o(e) {
    return e[e.length - 1];
  };

  function D(e, t) {
    if (null == e) return {};

    var r,
        n,
        i = function (e, t) {
      if (null == e) return {};
      var r,
          n,
          i = {},
          s = Object.keys(e);

      for (n = 0; n < s.length; n++) {
        r = s[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
      }

      return i;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var s = Object.getOwnPropertySymbols(e);

      for (n = 0; n < s.length; n++) {
        r = s[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
      }
    }

    return i;
  }

  var c = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  function p(e) {
    var t = {
      exports: {}
    };
    return e(t, t.exports), t.exports;
  }

  var l = function l(e) {
    return e && e.Math == Math && e;
  },
      h = l("object" == typeof globalThis && globalThis) || l("object" == typeof window && window) || l("object" == typeof self && self) || l("object" == typeof c && c) || function () {
    return this;
  }() || Function("return this")(),
      d = function d(e) {
    try {
      return !!e();
    } catch (e) {
      return !0;
    }
  },
      f = !d(function () {
    return 7 != Object.defineProperty({}, 1, {
      get: function get() {
        return 7;
      }
    })[1];
  }),
      E = {}.propertyIsEnumerable,
      C = Object.getOwnPropertyDescriptor,
      v = {
    f: C && !E.call({
      1: 2
    }, 1) ? function (e) {
      var t = C(this, e);
      return !!t && t.enumerable;
    } : E
  },
      F = function F(e, t) {
    return {
      enumerable: !(1 & e),
      configurable: !(2 & e),
      writable: !(4 & e),
      value: t
    };
  },
      g = {}.toString,
      m = function m(e) {
    return g.call(e).slice(8, -1);
  },
      y = "".split,
      x = d(function () {
    return !Object("z").propertyIsEnumerable(0);
  }) ? function (e) {
    return "String" == m(e) ? y.call(e, "") : Object(e);
  } : Object,
      A = function A(e) {
    if (null == e) throw TypeError("Can't call method on " + e);
    return e;
  },
      w = function w(e) {
    return x(A(e));
  },
      S = function S(e) {
    return "object" == typeof e ? null !== e : "function" == typeof e;
  },
      I = function I(e, t) {
    if (!S(e)) return e;
    var r, n;
    if (t && "function" == typeof (r = e.toString) && !S(n = r.call(e))) return n;
    if ("function" == typeof (r = e.valueOf) && !S(n = r.call(e))) return n;
    if (!t && "function" == typeof (r = e.toString) && !S(n = r.call(e))) return n;
    throw TypeError("Can't convert object to primitive value");
  },
      O = function O(e) {
    return Object(A(e));
  },
      N = {}.hasOwnProperty,
      b = Object.hasOwn || function (e, t) {
    return N.call(O(e), t);
  },
      B = h.document,
      P = S(B) && S(B.createElement),
      T = !f && !d(function () {
    return 7 != Object.defineProperty((e = "div", P ? B.createElement(e) : {}), "a", {
      get: function get() {
        return 7;
      }
    }).a;
    var e;
  }),
      L = Object.getOwnPropertyDescriptor,
      R = {
    f: f ? L : function (e, t) {
      if (e = w(e), t = I(t, !0), T) try {
        return L(e, t);
      } catch (e) {}
      if (b(e, t)) return F(!v.f.call(e, t), e[t]);
    }
  },
      k = function k(e) {
    if (!S(e)) throw TypeError(String(e) + " is not an object");
    return e;
  },
      $ = Object.defineProperty,
      _ = {
    f: f ? $ : function (e, t, r) {
      if (k(e), t = I(t, !0), k(r), T) try {
        return $(e, t, r);
      } catch (e) {}
      if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
      return "value" in r && (e[t] = r.value), e;
    }
  },
      M = f ? function (e, t, r) {
    return _.f(e, t, F(1, r));
  } : function (e, t, r) {
    return e[t] = r, e;
  },
      j = function j(e, t) {
    try {
      M(h, e, t);
    } catch (r) {
      h[e] = t;
    }

    return t;
  },
      G = "__core-js_shared__",
      K = h[G] || j(G, {}),
      U = Function.toString;

  "function" != typeof K.inspectSource && (K.inspectSource = function (e) {
    return U.call(e);
  });

  var W,
      V,
      X,
      z,
      q = K.inspectSource,
      Q = h.WeakMap,
      Y = "function" == typeof Q && /native code/.test(q(Q)),
      H = p(function (e) {
    (e.exports = function (e, t) {
      return K[e] || (K[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: "3.13.1",
      mode: "global",
      copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
    });
  }),
      J = 0,
      Z = Math.random(),
      ee = function ee(e) {
    return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++J + Z).toString(36);
  },
      te = H("keys"),
      re = {},
      ne = "Object already initialized",
      ie = h.WeakMap;

  if (Y || K.state) {
    var se = K.state || (K.state = new ie()),
        ue = se.get,
        ae = se.has,
        oe = se.set;
    W = function W(e, t) {
      if (ae.call(se, e)) throw new TypeError(ne);
      return t.facade = e, oe.call(se, e, t), t;
    }, V = function V(e) {
      return ue.call(se, e) || {};
    }, X = function X(e) {
      return ae.call(se, e);
    };
  } else {
    var De = te[z = "state"] || (te[z] = ee(z));
    re[De] = !0, W = function W(e, t) {
      if (b(e, De)) throw new TypeError(ne);
      return t.facade = e, M(e, De, t), t;
    }, V = function V(e) {
      return b(e, De) ? e[De] : {};
    }, X = function X(e) {
      return b(e, De);
    };
  }

  var ce,
      pe,
      le = {
    set: W,
    get: V,
    has: X,
    enforce: function enforce(e) {
      return X(e) ? V(e) : W(e, {});
    },
    getterFor: function getterFor(e) {
      return function (t) {
        var r;
        if (!S(t) || (r = V(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
        return r;
      };
    }
  },
      he = p(function (e) {
    var t = le.get,
        r = le.enforce,
        n = String(String).split("String");
    (e.exports = function (e, t, i, s) {
      var u,
          a = !!s && !!s.unsafe,
          o = !!s && !!s.enumerable,
          D = !!s && !!s.noTargetGet;
      "function" == typeof i && ("string" != typeof t || b(i, "name") || M(i, "name", t), (u = r(i)).source || (u.source = n.join("string" == typeof t ? t : ""))), e !== h ? (a ? !D && e[t] && (o = !0) : delete e[t], o ? e[t] = i : M(e, t, i)) : o ? e[t] = i : j(t, i);
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && t(this).source || q(this);
    });
  }),
      de = h,
      fe = function fe(e) {
    return "function" == typeof e ? e : void 0;
  },
      Ee = function Ee(e, t) {
    return arguments.length < 2 ? fe(de[e]) || fe(h[e]) : de[e] && de[e][t] || h[e] && h[e][t];
  },
      Ce = Math.ceil,
      ve = Math.floor,
      Fe = function Fe(e) {
    return isNaN(e = +e) ? 0 : (e > 0 ? ve : Ce)(e);
  },
      ge = Math.min,
      me = function me(e) {
    return e > 0 ? ge(Fe(e), 9007199254740991) : 0;
  },
      ye = Math.max,
      xe = Math.min,
      Ae = function Ae(e) {
    return function (t, r, n) {
      var i,
          s = w(t),
          u = me(s.length),
          a = function (e, t) {
        var r = Fe(e);
        return r < 0 ? ye(r + t, 0) : xe(r, t);
      }(n, u);

      if (e && r != r) {
        for (; u > a;) {
          if ((i = s[a++]) != i) return !0;
        }
      } else for (; u > a; a++) {
        if ((e || a in s) && s[a] === r) return e || a || 0;
      }

      return !e && -1;
    };
  },
      we = {
    includes: Ae(!0),
    indexOf: Ae(!1)
  }.indexOf,
      Se = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"].concat("length", "prototype"),
      Ie = {
    f: Object.getOwnPropertyNames || function (e) {
      return function (e, t) {
        var r,
            n = w(e),
            i = 0,
            s = [];

        for (r in n) {
          !b(re, r) && b(n, r) && s.push(r);
        }

        for (; t.length > i;) {
          b(n, r = t[i++]) && (~we(s, r) || s.push(r));
        }

        return s;
      }(e, Se);
    }
  },
      Oe = {
    f: Object.getOwnPropertySymbols
  },
      Ne = Ee("Reflect", "ownKeys") || function (e) {
    var t = Ie.f(k(e)),
        r = Oe.f;
    return r ? t.concat(r(e)) : t;
  },
      be = function be(e, t) {
    for (var r = Ne(t), n = _.f, i = R.f, s = 0; s < r.length; s++) {
      var u = r[s];
      b(e, u) || n(e, u, i(t, u));
    }
  },
      Be = /#|\.prototype\./,
      Pe = function Pe(e, t) {
    var r = Le[Te(e)];
    return r == ke || r != Re && ("function" == typeof t ? d(t) : !!t);
  },
      Te = Pe.normalize = function (e) {
    return String(e).replace(Be, ".").toLowerCase();
  },
      Le = Pe.data = {},
      Re = Pe.NATIVE = "N",
      ke = Pe.POLYFILL = "P",
      $e = Pe,
      _e = R.f,
      Me = function Me(e, t) {
    var r,
        n,
        i,
        s,
        u,
        a = e.target,
        o = e.global,
        D = e.stat;
    if (r = o ? h : D ? h[a] || j(a, {}) : (h[a] || {}).prototype) for (n in t) {
      if (s = t[n], i = e.noTargetGet ? (u = _e(r, n)) && u.value : r[n], !$e(o ? n : a + (D ? "." : "#") + n, e.forced) && void 0 !== i) {
        if (typeof s == typeof i) continue;
        be(s, i);
      }

      (e.sham || i && i.sham) && M(s, "sham", !0), he(r, n, s, e);
    }
  },
      je = Array.isArray || function (e) {
    return "Array" == m(e);
  },
      Ge = function Ge(e) {
    if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
    return e;
  },
      Ke = function Ke(e, t, r) {
    if (Ge(e), void 0 === t) return e;

    switch (r) {
      case 0:
        return function () {
          return e.call(t);
        };

      case 1:
        return function (r) {
          return e.call(t, r);
        };

      case 2:
        return function (r, n) {
          return e.call(t, r, n);
        };

      case 3:
        return function (r, n, i) {
          return e.call(t, r, n, i);
        };
    }

    return function () {
      return e.apply(t, arguments);
    };
  },
      Ue = function Ue(e, t, r, n, i, s, u, a) {
    for (var o, D = i, c = 0, p = !!u && Ke(u, a, 3); c < n;) {
      if (c in r) {
        if (o = p ? p(r[c], c, t) : r[c], s > 0 && je(o)) D = Ue(e, t, o, me(o.length), D, s - 1) - 1;else {
          if (D >= 9007199254740991) throw TypeError("Exceed the acceptable array length");
          e[D] = o;
        }
        D++;
      }

      c++;
    }

    return D;
  },
      We = Ue,
      Ve = Ee("navigator", "userAgent") || "",
      Xe = h.process,
      ze = Xe && Xe.versions,
      qe = ze && ze.v8;

  qe ? pe = (ce = qe.split("."))[0] < 4 ? 1 : ce[0] + ce[1] : Ve && (!(ce = Ve.match(/Edge\/(\d+)/)) || ce[1] >= 74) && (ce = Ve.match(/Chrome\/(\d+)/)) && (pe = ce[1]);

  var Qe = pe && +pe,
      Ye = !!Object.getOwnPropertySymbols && !d(function () {
    var e = Symbol();
    return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && Qe && Qe < 41;
  }),
      He = Ye && !Symbol.sham && "symbol" == typeof Symbol.iterator,
      Je = H("wks"),
      Ze = h.Symbol,
      et = He ? Ze : Ze && Ze.withoutSetter || ee,
      tt = function tt(e) {
    return b(Je, e) && (Ye || "string" == typeof Je[e]) || (Ye && b(Ze, e) ? Je[e] = Ze[e] : Je[e] = et("Symbol." + e)), Je[e];
  },
      rt = tt("species"),
      nt = function nt(e, t) {
    var r;
    return je(e) && ("function" != typeof (r = e.constructor) || r !== Array && !je(r.prototype) ? S(r) && null === (r = r[rt]) && (r = void 0) : r = void 0), new (void 0 === r ? Array : r)(0 === t ? 0 : t);
  };

  Me({
    target: "Array",
    proto: !0
  }, {
    flatMap: function flatMap(e) {
      var t,
          r = O(this),
          n = me(r.length);
      return Ge(e), (t = nt(r, 0)).length = We(t, r, r, n, 0, 1, e, arguments.length > 1 ? arguments[1] : void 0), t;
    }
  });
  var it = {},
      st = tt("iterator"),
      ut = Array.prototype,
      at = {};
  at[tt("toStringTag")] = "z";

  var ot = "[object z]" === String(at),
      Dt = tt("toStringTag"),
      ct = "Arguments" == m(function () {
    return arguments;
  }()),
      pt = ot ? m : function (e) {
    var t, r, n;
    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function (e, t) {
      try {
        return e[t];
      } catch (e) {}
    }(t = Object(e), Dt)) ? r : ct ? m(t) : "Object" == (n = m(t)) && "function" == typeof t.callee ? "Arguments" : n;
  },
      lt = tt("iterator"),
      ht = function ht(e) {
    var t = e.return;
    if (void 0 !== t) return k(t.call(e)).value;
  },
      dt = function dt(e, t) {
    this.stopped = e, this.result = t;
  },
      ft = function ft(e, t, r) {
    var n,
        i,
        s,
        u,
        a,
        o,
        D,
        c,
        p = r && r.that,
        l = !(!r || !r.AS_ENTRIES),
        h = !(!r || !r.IS_ITERATOR),
        d = !(!r || !r.INTERRUPTED),
        f = Ke(t, p, 1 + l + d),
        E = function E(e) {
      return n && ht(n), new dt(!0, e);
    },
        C = function C(e) {
      return l ? (k(e), d ? f(e[0], e[1], E) : f(e[0], e[1])) : d ? f(e, E) : f(e);
    };

    if (h) n = e;else {
      if ("function" != typeof (i = function (e) {
        if (null != e) return e[lt] || e["@@iterator"] || it[pt(e)];
      }(e))) throw TypeError("Target is not iterable");

      if (void 0 !== (c = i) && (it.Array === c || ut[st] === c)) {
        for (s = 0, u = me(e.length); u > s; s++) {
          if ((a = C(e[s])) && a instanceof dt) return a;
        }

        return new dt(!1);
      }

      n = i.call(e);
    }

    for (o = n.next; !(D = o.call(n)).done;) {
      try {
        a = C(D.value);
      } catch (e) {
        throw ht(n), e;
      }

      if ("object" == typeof a && a && a instanceof dt) return a;
    }

    return new dt(!1);
  };

  Me({
    target: "Object",
    stat: !0
  }, {
    fromEntries: function fromEntries(e) {
      var t = {};
      return ft(e, function (e, r) {
        !function (e, t, r) {
          var n = I(t);
          n in e ? _.f(e, n, F(0, r)) : e[n] = r;
        }(t, e, r);
      }, {
        AS_ENTRIES: !0
      }), t;
    }
  });
  var Et = void 0 !== Et ? Et : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};

  function Ct() {
    throw new Error("setTimeout has not been defined");
  }

  function vt() {
    throw new Error("clearTimeout has not been defined");
  }

  var Ft = Ct,
      gt = vt;

  function mt(e) {
    if (Ft === setTimeout) return setTimeout(e, 0);
    if ((Ft === Ct || !Ft) && setTimeout) return Ft = setTimeout, setTimeout(e, 0);

    try {
      return Ft(e, 0);
    } catch (t) {
      try {
        return Ft.call(null, e, 0);
      } catch (t) {
        return Ft.call(this, e, 0);
      }
    }
  }

  "function" == typeof Et.setTimeout && (Ft = setTimeout), "function" == typeof Et.clearTimeout && (gt = clearTimeout);
  var yt,
      xt = [],
      At = !1,
      wt = -1;

  function St() {
    At && yt && (At = !1, yt.length ? xt = yt.concat(xt) : wt = -1, xt.length && It());
  }

  function It() {
    if (!At) {
      var e = mt(St);
      At = !0;

      for (var t = xt.length; t;) {
        for (yt = xt, xt = []; ++wt < t;) {
          yt && yt[wt].run();
        }

        wt = -1, t = xt.length;
      }

      yt = null, At = !1, function (e) {
        if (gt === clearTimeout) return clearTimeout(e);
        if ((gt === vt || !gt) && clearTimeout) return gt = clearTimeout, clearTimeout(e);

        try {
          gt(e);
        } catch (t) {
          try {
            return gt.call(null, e);
          } catch (t) {
            return gt.call(this, e);
          }
        }
      }(e);
    }
  }

  function Ot(e, t) {
    this.fun = e, this.array = t;
  }

  Ot.prototype.run = function () {
    this.fun.apply(null, this.array);
  };

  function Nt() {}

  var bt = Nt,
      Bt = Nt,
      Pt = Nt,
      Tt = Nt,
      Lt = Nt,
      Rt = Nt,
      kt = Nt;

  var $t = Et.performance || {},
      _t = $t.now || $t.mozNow || $t.msNow || $t.oNow || $t.webkitNow || function () {
    return new Date().getTime();
  };

  var Mt = new Date();
  var jt = {
    nextTick: function nextTick(e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
        t[r - 1] = arguments[r];
      }
      xt.push(new Ot(e, t)), 1 !== xt.length || At || mt(It);
    },
    title: "browser",
    browser: !0,
    env: {},
    argv: [],
    version: "",
    versions: {},
    on: bt,
    addListener: Bt,
    once: Pt,
    off: Tt,
    removeListener: Lt,
    removeAllListeners: Rt,
    emit: kt,
    binding: function binding(e) {
      throw new Error("process.binding is not supported");
    },
    cwd: function cwd() {
      return "/";
    },
    chdir: function chdir(e) {
      throw new Error("process.chdir is not supported");
    },
    umask: function umask() {
      return 0;
    },
    hrtime: function hrtime(e) {
      var t = .001 * _t.call($t),
          r = Math.floor(t),
          n = Math.floor(t % 1 * 1e9);

      return e && (r -= e[0], (n -= e[1]) < 0 && (r--, n += 1e9)), [r, n];
    },
    platform: "browser",
    release: {},
    config: {},
    uptime: function uptime() {
      return (new Date() - Mt) / 1e3;
    }
  };
  var Gt = "object" == typeof jt && jt.env && jt.env.NODE_DEBUG && /\bsemver\b/i.test(jt.env.NODE_DEBUG) ? function () {
    var _console;

    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    return (_console = console).error.apply(_console, ["SEMVER"].concat(e));
  } : function () {};
  var Kt = {
    SEMVER_SPEC_VERSION: "2.0.0",
    MAX_LENGTH: 256,
    MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER || 9007199254740991,
    MAX_SAFE_COMPONENT_LENGTH: 16
  },
      Ut = p(function (e, t) {
    var r = Kt.MAX_SAFE_COMPONENT_LENGTH,
        n = (t = e.exports = {}).re = [],
        i = t.src = [],
        s = t.t = {};
    var u = 0;

    var a = function a(e, t, r) {
      var a = u++;
      Gt(a, t), s[e] = a, i[a] = t, n[a] = new RegExp(t, r ? "g" : void 0);
    };

    a("NUMERICIDENTIFIER", "0|[1-9]\\d*"), a("NUMERICIDENTIFIERLOOSE", "[0-9]+"), a("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), a("MAINVERSION", "(".concat(i[s.NUMERICIDENTIFIER], ")\\.(").concat(i[s.NUMERICIDENTIFIER], ")\\.(").concat(i[s.NUMERICIDENTIFIER], ")")), a("MAINVERSIONLOOSE", "(".concat(i[s.NUMERICIDENTIFIERLOOSE], ")\\.(").concat(i[s.NUMERICIDENTIFIERLOOSE], ")\\.(").concat(i[s.NUMERICIDENTIFIERLOOSE], ")")), a("PRERELEASEIDENTIFIER", "(?:".concat(i[s.NUMERICIDENTIFIER], "|").concat(i[s.NONNUMERICIDENTIFIER], ")")), a("PRERELEASEIDENTIFIERLOOSE", "(?:".concat(i[s.NUMERICIDENTIFIERLOOSE], "|").concat(i[s.NONNUMERICIDENTIFIER], ")")), a("PRERELEASE", "(?:-(".concat(i[s.PRERELEASEIDENTIFIER], "(?:\\.").concat(i[s.PRERELEASEIDENTIFIER], ")*))")), a("PRERELEASELOOSE", "(?:-?(".concat(i[s.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(i[s.PRERELEASEIDENTIFIERLOOSE], ")*))")), a("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), a("BUILD", "(?:\\+(".concat(i[s.BUILDIDENTIFIER], "(?:\\.").concat(i[s.BUILDIDENTIFIER], ")*))")), a("FULLPLAIN", "v?".concat(i[s.MAINVERSION]).concat(i[s.PRERELEASE], "?").concat(i[s.BUILD], "?")), a("FULL", "^".concat(i[s.FULLPLAIN], "$")), a("LOOSEPLAIN", "[v=\\s]*".concat(i[s.MAINVERSIONLOOSE]).concat(i[s.PRERELEASELOOSE], "?").concat(i[s.BUILD], "?")), a("LOOSE", "^".concat(i[s.LOOSEPLAIN], "$")), a("GTLT", "((?:<|>)?=?)"), a("XRANGEIDENTIFIERLOOSE", "".concat(i[s.NUMERICIDENTIFIERLOOSE], "|x|X|\\*")), a("XRANGEIDENTIFIER", "".concat(i[s.NUMERICIDENTIFIER], "|x|X|\\*")), a("XRANGEPLAIN", "[v=\\s]*(".concat(i[s.XRANGEIDENTIFIER], ")(?:\\.(").concat(i[s.XRANGEIDENTIFIER], ")(?:\\.(").concat(i[s.XRANGEIDENTIFIER], ")(?:").concat(i[s.PRERELEASE], ")?").concat(i[s.BUILD], "?)?)?")), a("XRANGEPLAINLOOSE", "[v=\\s]*(".concat(i[s.XRANGEIDENTIFIERLOOSE], ")(?:\\.(").concat(i[s.XRANGEIDENTIFIERLOOSE], ")(?:\\.(").concat(i[s.XRANGEIDENTIFIERLOOSE], ")(?:").concat(i[s.PRERELEASELOOSE], ")?").concat(i[s.BUILD], "?)?)?")), a("XRANGE", "^".concat(i[s.GTLT], "\\s*").concat(i[s.XRANGEPLAIN], "$")), a("XRANGELOOSE", "^".concat(i[s.GTLT], "\\s*").concat(i[s.XRANGEPLAINLOOSE], "$")), a("COERCE", "(^|[^\\d])(\\d{1,".concat(r, "})(?:\\.(\\d{1,").concat(r, "}))?(?:\\.(\\d{1,").concat(r, "}))?(?:$|[^\\d])")), a("COERCERTL", i[s.COERCE], !0), a("LONETILDE", "(?:~>?)"), a("TILDETRIM", "(\\s*)".concat(i[s.LONETILDE], "\\s+"), !0), t.tildeTrimReplace = "$1~", a("TILDE", "^".concat(i[s.LONETILDE]).concat(i[s.XRANGEPLAIN], "$")), a("TILDELOOSE", "^".concat(i[s.LONETILDE]).concat(i[s.XRANGEPLAINLOOSE], "$")), a("LONECARET", "(?:\\^)"), a("CARETTRIM", "(\\s*)".concat(i[s.LONECARET], "\\s+"), !0), t.caretTrimReplace = "$1^", a("CARET", "^".concat(i[s.LONECARET]).concat(i[s.XRANGEPLAIN], "$")), a("CARETLOOSE", "^".concat(i[s.LONECARET]).concat(i[s.XRANGEPLAINLOOSE], "$")), a("COMPARATORLOOSE", "^".concat(i[s.GTLT], "\\s*(").concat(i[s.LOOSEPLAIN], ")$|^$")), a("COMPARATOR", "^".concat(i[s.GTLT], "\\s*(").concat(i[s.FULLPLAIN], ")$|^$")), a("COMPARATORTRIM", "(\\s*)".concat(i[s.GTLT], "\\s*(").concat(i[s.LOOSEPLAIN], "|").concat(i[s.XRANGEPLAIN], ")"), !0), t.comparatorTrimReplace = "$1$2$3", a("HYPHENRANGE", "^\\s*(".concat(i[s.XRANGEPLAIN], ")\\s+-\\s+(").concat(i[s.XRANGEPLAIN], ")\\s*$")), a("HYPHENRANGELOOSE", "^\\s*(".concat(i[s.XRANGEPLAINLOOSE], ")\\s+-\\s+(").concat(i[s.XRANGEPLAINLOOSE], ")\\s*$")), a("STAR", "(<|>)?=?\\s*\\*"), a("GTE0", "^\\s*>=\\s*0.0.0\\s*$"), a("GTE0PRE", "^\\s*>=\\s*0.0.0-0\\s*$");
  });
  var Wt = ["includePrerelease", "loose", "rtl"];

  var Vt = function Vt(e) {
    return e ? "object" != typeof e ? {
      loose: !0
    } : Wt.filter(function (t) {
      return e[t];
    }).reduce(function (e, t) {
      return e[t] = !0, e;
    }, {}) : {};
  };

  var Xt = /^[0-9]+$/,
      zt = function zt(e, t) {
    var r = Xt.test(e),
        n = Xt.test(t);
    return r && n && (e = +e, t = +t), e === t ? 0 : r && !n ? -1 : n && !r ? 1 : e < t ? -1 : 1;
  };

  var qt = {
    compareIdentifiers: zt,
    rcompareIdentifiers: function rcompareIdentifiers(e, t) {
      return zt(t, e);
    }
  };
  var Qt = Kt.MAX_LENGTH,
      Yt = Kt.MAX_SAFE_INTEGER,
      Ht = Ut.re,
      Jt = Ut.t,
      Zt = qt.compareIdentifiers;

  var er = /*#__PURE__*/function () {
    function er(e, t) {
      _classCallCheck(this, er);

      if (t = Vt(t), e instanceof er) {
        if (e.loose === !!t.loose && e.includePrerelease === !!t.includePrerelease) return e;
        e = e.version;
      } else if ("string" != typeof e) throw new TypeError("Invalid Version: ".concat(e));

      if (e.length > Qt) throw new TypeError("version is longer than ".concat(Qt, " characters"));
      Gt("SemVer", e, t), this.options = t, this.loose = !!t.loose, this.includePrerelease = !!t.includePrerelease;
      var r = e.trim().match(t.loose ? Ht[Jt.LOOSE] : Ht[Jt.FULL]);
      if (!r) throw new TypeError("Invalid Version: ".concat(e));
      if (this.raw = e, this.major = +r[1], this.minor = +r[2], this.patch = +r[3], this.major > Yt || this.major < 0) throw new TypeError("Invalid major version");
      if (this.minor > Yt || this.minor < 0) throw new TypeError("Invalid minor version");
      if (this.patch > Yt || this.patch < 0) throw new TypeError("Invalid patch version");
      r[4] ? this.prerelease = r[4].split(".").map(function (e) {
        if (/^[0-9]+$/.test(e)) {
          var _t2 = +e;

          if (_t2 >= 0 && _t2 < Yt) return _t2;
        }

        return e;
      }) : this.prerelease = [], this.build = r[5] ? r[5].split(".") : [], this.format();
    }

    _createClass(er, [{
      key: "format",
      value: function format() {
        return this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch), this.prerelease.length && (this.version += "-".concat(this.prerelease.join("."))), this.version;
      }
    }, {
      key: "toString",
      value: function toString() {
        return this.version;
      }
    }, {
      key: "compare",
      value: function compare(e) {
        if (Gt("SemVer.compare", this.version, this.options, e), !(e instanceof er)) {
          if ("string" == typeof e && e === this.version) return 0;
          e = new er(e, this.options);
        }

        return e.version === this.version ? 0 : this.compareMain(e) || this.comparePre(e);
      }
    }, {
      key: "compareMain",
      value: function compareMain(e) {
        return e instanceof er || (e = new er(e, this.options)), Zt(this.major, e.major) || Zt(this.minor, e.minor) || Zt(this.patch, e.patch);
      }
    }, {
      key: "comparePre",
      value: function comparePre(e) {
        if (e instanceof er || (e = new er(e, this.options)), this.prerelease.length && !e.prerelease.length) return -1;
        if (!this.prerelease.length && e.prerelease.length) return 1;
        if (!this.prerelease.length && !e.prerelease.length) return 0;
        var t = 0;

        do {
          var _r2 = this.prerelease[t],
              _n2 = e.prerelease[t];
          if (Gt("prerelease compare", t, _r2, _n2), void 0 === _r2 && void 0 === _n2) return 0;
          if (void 0 === _n2) return 1;
          if (void 0 === _r2) return -1;
          if (_r2 !== _n2) return Zt(_r2, _n2);
        } while (++t);
      }
    }, {
      key: "compareBuild",
      value: function compareBuild(e) {
        e instanceof er || (e = new er(e, this.options));
        var t = 0;

        do {
          var _r3 = this.build[t],
              _n3 = e.build[t];
          if (Gt("prerelease compare", t, _r3, _n3), void 0 === _r3 && void 0 === _n3) return 0;
          if (void 0 === _n3) return 1;
          if (void 0 === _r3) return -1;
          if (_r3 !== _n3) return Zt(_r3, _n3);
        } while (++t);
      }
    }, {
      key: "inc",
      value: function inc(e, t) {
        switch (e) {
          case "premajor":
            this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", t);
            break;

          case "preminor":
            this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", t);
            break;

          case "prepatch":
            this.prerelease.length = 0, this.inc("patch", t), this.inc("pre", t);
            break;

          case "prerelease":
            0 === this.prerelease.length && this.inc("patch", t), this.inc("pre", t);
            break;

          case "major":
            0 === this.minor && 0 === this.patch && 0 !== this.prerelease.length || this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
            break;

          case "minor":
            0 === this.patch && 0 !== this.prerelease.length || this.minor++, this.patch = 0, this.prerelease = [];
            break;

          case "patch":
            0 === this.prerelease.length && this.patch++, this.prerelease = [];
            break;

          case "pre":
            if (0 === this.prerelease.length) this.prerelease = [0];else {
              var _e4 = this.prerelease.length;

              for (; --_e4 >= 0;) {
                "number" == typeof this.prerelease[_e4] && (this.prerelease[_e4]++, _e4 = -2);
              }

              -1 === _e4 && this.prerelease.push(0);
            }
            t && (this.prerelease[0] === t ? isNaN(this.prerelease[1]) && (this.prerelease = [t, 0]) : this.prerelease = [t, 0]);
            break;

          default:
            throw new Error("invalid increment argument: ".concat(e));
        }

        return this.format(), this.raw = this.version, this;
      }
    }]);

    return er;
  }();

  var tr = er;

  var rr = function rr(e, t, r) {
    return new tr(e, r).compare(new tr(t, r));
  };

  var nr = function nr(e, t, r) {
    return rr(e, t, r) < 0;
  };

  var ir = function ir(e, t, r) {
    return rr(e, t, r) >= 0;
  },
      sr = "2.3.1",
      ur = p(function (e, t) {
    function r() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }
    }

    function n() {
      return "undefined" != typeof WeakMap ? new WeakMap() : {
        add: r,
        delete: r,
        get: r,
        set: r,
        has: function has(e) {
          return !1;
        }
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.outdent = void 0;

    var i = Object.prototype.hasOwnProperty,
        s = function s(e, t) {
      return i.call(e, t);
    };

    function u(e, t) {
      for (var r in t) {
        s(t, r) && (e[r] = t[r]);
      }

      return e;
    }

    var a = /^[ \t]*(?:\r\n|\r|\n)/,
        o = /(?:\r\n|\r|\n)[ \t]*$/,
        D = /^(?:[\r\n]|$)/,
        c = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/,
        p = /^[ \t]*[\r\n][ \t\r\n]*$/;

    function l(e, t, r) {
      var n = 0,
          i = e[0].match(c);
      i && (n = i[1].length);
      var s = new RegExp("(\\r\\n|\\r|\\n).{0," + n + "}", "g");
      t && (e = e.slice(1));
      var u = r.newline,
          D = r.trimLeadingNewline,
          p = r.trimTrailingNewline,
          l = "string" == typeof u,
          h = e.length;
      return e.map(function (e, t) {
        return e = e.replace(s, "$1"), 0 === t && D && (e = e.replace(a, "")), t === h - 1 && p && (e = e.replace(o, "")), l && (e = e.replace(/\r\n|\n|\r/g, function (e) {
          return u;
        })), e;
      });
    }

    function h(e, t) {
      for (var r = "", n = 0, i = e.length; n < i; n++) {
        r += e[n], n < i - 1 && (r += t[n]);
      }

      return r;
    }

    function d(e) {
      return s(e, "raw") && s(e, "length");
    }

    var f = function e(t) {
      var r = n(),
          i = n();
      return u(function n(s) {
        for (var a = [], o = 1; o < arguments.length; o++) {
          a[o - 1] = arguments[o];
        }

        if (d(s)) {
          var c = s,
              E = (a[0] === n || a[0] === f) && p.test(c[0]) && D.test(c[1]),
              C = E ? i : r,
              v = C.get(c);
          if (v || (v = l(c, E, t), C.set(c, v)), 0 === a.length) return v[0];
          var F = h(v, E ? a.slice(1) : a);
          return F;
        }

        return e(u(u({}, t), s || {}));
      }, {
        string: function string(e) {
          return l([e], !1, t)[0];
        }
      });
    }({
      trimLeadingNewline: !0,
      trimTrailingNewline: !0
    });

    t.outdent = f, t.default = f;

    try {
      e.exports = f, Object.defineProperty(f, "__esModule", {
        value: !0
      }), f.default = f, f.outdent = f;
    } catch (e) {}
  });

  var ar = ur.outdent,
      or = "Config",
      Dr = "Editor",
      cr = "Other",
      pr = "Global",
      lr = "Special",
      hr = {
    cursorOffset: {
      since: "1.4.0",
      category: lr,
      type: "int",
      default: -1,
      range: {
        start: -1,
        end: Number.POSITIVE_INFINITY,
        step: 1
      },
      description: ar(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      Print (to stderr) where a cursor at the given position would move to after formatting.\n      This option cannot be used with --range-start and --range-end.\n    "]))),
      cliCategory: Dr
    },
    endOfLine: {
      since: "1.15.0",
      category: pr,
      type: "choice",
      default: [{
        since: "1.15.0",
        value: "auto"
      }, {
        since: "2.0.0",
        value: "lf"
      }],
      description: "Which end of line characters to apply.",
      choices: [{
        value: "lf",
        description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos"
      }, {
        value: "crlf",
        description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows"
      }, {
        value: "cr",
        description: "Carriage Return character only (\\r), used very rarely"
      }, {
        value: "auto",
        description: ar(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          Maintain existing\n          (mixed values within one file are normalised by looking at what's used after the first line)\n        "])))
      }]
    },
    filepath: {
      since: "1.4.0",
      category: lr,
      type: "path",
      description: "Specify the input filepath. This will be used to do parser inference.",
      cliName: "stdin-filepath",
      cliCategory: cr,
      cliDescription: "Path to the file to pretend that stdin comes from."
    },
    insertPragma: {
      since: "1.8.0",
      category: lr,
      type: "boolean",
      default: !1,
      description: "Insert @format pragma into file's first docblock comment.",
      cliCategory: cr
    },
    parser: {
      since: "0.0.10",
      category: pr,
      type: "choice",
      default: [{
        since: "0.0.10",
        value: "babylon"
      }, {
        since: "1.13.0",
        value: void 0
      }],
      description: "Which parser to use.",
      exception: function exception(e) {
        return "string" == typeof e || "function" == typeof e;
      },
      choices: [{
        value: "flow",
        description: "Flow"
      }, {
        value: "babel",
        since: "1.16.0",
        description: "JavaScript"
      }, {
        value: "babel-flow",
        since: "1.16.0",
        description: "Flow"
      }, {
        value: "babel-ts",
        since: "2.0.0",
        description: "TypeScript"
      }, {
        value: "typescript",
        since: "1.4.0",
        description: "TypeScript"
      }, {
        value: "espree",
        since: "2.2.0",
        description: "JavaScript"
      }, {
        value: "meriyah",
        since: "2.2.0",
        description: "JavaScript"
      }, {
        value: "css",
        since: "1.7.1",
        description: "CSS"
      }, {
        value: "less",
        since: "1.7.1",
        description: "Less"
      }, {
        value: "scss",
        since: "1.7.1",
        description: "SCSS"
      }, {
        value: "json",
        since: "1.5.0",
        description: "JSON"
      }, {
        value: "json5",
        since: "1.13.0",
        description: "JSON5"
      }, {
        value: "json-stringify",
        since: "1.13.0",
        description: "JSON.stringify"
      }, {
        value: "graphql",
        since: "1.5.0",
        description: "GraphQL"
      }, {
        value: "markdown",
        since: "1.8.0",
        description: "Markdown"
      }, {
        value: "mdx",
        since: "1.15.0",
        description: "MDX"
      }, {
        value: "vue",
        since: "1.10.0",
        description: "Vue"
      }, {
        value: "yaml",
        since: "1.14.0",
        description: "YAML"
      }, {
        value: "glimmer",
        since: "2.3.0",
        description: "Ember / Handlebars"
      }, {
        value: "html",
        since: "1.15.0",
        description: "HTML"
      }, {
        value: "angular",
        since: "1.15.0",
        description: "Angular"
      }, {
        value: "lwc",
        since: "1.17.0",
        description: "Lightning Web Components"
      }]
    },
    plugins: {
      since: "1.10.0",
      type: "path",
      array: !0,
      default: [{
        value: []
      }],
      category: pr,
      description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.",
      exception: function exception(e) {
        return "string" == typeof e || "object" == typeof e;
      },
      cliName: "plugin",
      cliCategory: or
    },
    pluginSearchDirs: {
      since: "1.13.0",
      type: "path",
      array: !0,
      default: [{
        value: []
      }],
      category: pr,
      description: ar(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      Custom directory that contains prettier plugins in node_modules subdirectory.\n      Overrides default behavior when plugins are searched relatively to the location of Prettier.\n      Multiple values are accepted.\n    "]))),
      exception: function exception(e) {
        return "string" == typeof e || "object" == typeof e;
      },
      cliName: "plugin-search-dir",
      cliCategory: or
    },
    printWidth: {
      since: "0.0.0",
      category: pr,
      type: "int",
      default: 80,
      description: "The line length where Prettier will try wrap.",
      range: {
        start: 0,
        end: Number.POSITIVE_INFINITY,
        step: 1
      }
    },
    rangeEnd: {
      since: "1.4.0",
      category: lr,
      type: "int",
      default: Number.POSITIVE_INFINITY,
      range: {
        start: 0,
        end: Number.POSITIVE_INFINITY,
        step: 1
      },
      description: ar(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      Format code ending at a given character offset (exclusive).\n      The range will extend forwards to the end of the selected statement.\n      This option cannot be used with --cursor-offset.\n    "]))),
      cliCategory: Dr
    },
    rangeStart: {
      since: "1.4.0",
      category: lr,
      type: "int",
      default: 0,
      range: {
        start: 0,
        end: Number.POSITIVE_INFINITY,
        step: 1
      },
      description: ar(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      Format code starting at a given character offset.\n      The range will extend backwards to the start of the first line containing the selected statement.\n      This option cannot be used with --cursor-offset.\n    "]))),
      cliCategory: Dr
    },
    requirePragma: {
      since: "1.7.0",
      category: lr,
      type: "boolean",
      default: !1,
      description: ar(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      Require either '@prettier' or '@format' to be present in the file's first docblock comment\n      in order for it to be formatted.\n    "]))),
      cliCategory: cr
    },
    tabWidth: {
      type: "int",
      category: pr,
      default: 2,
      description: "Number of spaces per indentation level.",
      range: {
        start: 0,
        end: Number.POSITIVE_INFINITY,
        step: 1
      }
    },
    useTabs: {
      since: "1.0.0",
      category: pr,
      type: "boolean",
      default: !1,
      description: "Indent with tabs instead of spaces."
    },
    embeddedLanguageFormatting: {
      since: "2.1.0",
      category: pr,
      type: "choice",
      default: [{
        since: "2.1.0",
        value: "auto"
      }],
      description: "Control how Prettier formats quoted code embedded in the file.",
      choices: [{
        value: "auto",
        description: "Format embedded code if Prettier can automatically identify it."
      }, {
        value: "off",
        description: "Never automatically format embedded code."
      }]
    }
  };
  var dr = ["cliName", "cliCategory", "cliDescription"],
      fr = {
    compare: rr,
    lt: nr,
    gte: ir
  },
      Er = sr,
      Cr = {
    CATEGORY_CONFIG: or,
    CATEGORY_EDITOR: Dr,
    CATEGORY_FORMAT: "Format",
    CATEGORY_OTHER: cr,
    CATEGORY_OUTPUT: "Output",
    CATEGORY_GLOBAL: pr,
    CATEGORY_SPECIAL: lr,
    options: hr
  }.options;
  var vr = {
    getSupportInfo: function getSupportInfo() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$plugins = _ref2.plugins,
          e = _ref2$plugins === void 0 ? [] : _ref2$plugins,
          _ref2$showUnreleased = _ref2.showUnreleased,
          t = _ref2$showUnreleased === void 0 ? !1 : _ref2$showUnreleased,
          _ref2$showDeprecated = _ref2.showDeprecated,
          r = _ref2$showDeprecated === void 0 ? !1 : _ref2$showDeprecated,
          _ref2$showInternal = _ref2.showInternal,
          n = _ref2$showInternal === void 0 ? !1 : _ref2$showInternal;

      var i = Er.split("-", 1)[0],
          s = e.flatMap(function (e) {
        return e.languages || [];
      }).filter(c),
          u = (a = Object.assign.apply(Object, [{}].concat(_toConsumableArray(e.map(function (_ref3) {
        var e = _ref3.options;
        return e;
      })), [Cr])), o = "name", Object.entries(a).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            e = _ref5[0],
            t = _ref5[1];

        return Object.assign(_defineProperty({}, o, e), t);
      })).filter(function (e) {
        return c(e) && p(e);
      }).sort(function (e, t) {
        return e.name === t.name ? 0 : e.name < t.name ? -1 : 1;
      }).map(function (e) {
        if (n) return e;
        return D(e, dr);
      }).map(function (t) {
        t = Object.assign({}, t), Array.isArray(t.default) && (t.default = 1 === t.default.length ? t.default[0].value : t.default.filter(c).sort(function (e, t) {
          return fr.compare(t.since, e.since);
        })[0].value), Array.isArray(t.choices) && (t.choices = t.choices.filter(function (e) {
          return c(e) && p(e);
        }), "parser" === t.name && function (e, t, r) {
          var n = new Set(e.choices.map(function (e) {
            return e.value;
          }));

          var _iterator = _createForOfIteratorHelper(t),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _i2 = _step.value;

              if (_i2.parsers) {
                var _iterator2 = _createForOfIteratorHelper(_i2.parsers),
                    _step2;

                try {
                  var _loop = function _loop() {
                    var t = _step2.value;

                    if (!n.has(t)) {
                      n.add(t);

                      var _s = r.find(function (e) {
                        return e.parsers && e.parsers[t];
                      });

                      var _u = _i2.name;
                      _s && _s.name && (_u += " (plugin: ".concat(_s.name, ")")), e.choices.push({
                        value: t,
                        description: _u
                      });
                    }
                  };

                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }(t, s, e));
        var r = Object.fromEntries(e.filter(function (e) {
          return e.defaultOptions && void 0 !== e.defaultOptions[t.name];
        }).map(function (e) {
          return [e.name, e.defaultOptions[t.name]];
        }));
        return Object.assign(Object.assign({}, t), {}, {
          pluginDefaults: r
        });
      });
      var a, o;
      return {
        languages: s,
        options: u
      };

      function c(e) {
        return t || !("since" in e) || e.since && fr.gte(i, e.since);
      }

      function p(e) {
        return r || !("deprecated" in e) || e.deprecated && fr.lt(i, e.deprecated);
      }
    }
  };
  var Fr = vr.getSupportInfo,
      gr = /[^\x20-\x7F]/;

  function mr(e) {
    return function (t, r, n) {
      var i = n && n.backwards;
      if (!1 === r) return !1;
      var s = t.length;
      var u = r;

      for (; u >= 0 && u < s;) {
        var _r4 = t.charAt(u);

        if (e instanceof RegExp) {
          if (!e.test(_r4)) return u;
        } else if (!e.includes(_r4)) return u;

        i ? u-- : u++;
      }

      return (-1 === u || u === s) && u;
    };
  }

  var yr = mr(/\s/),
      xr = mr(" \t"),
      Ar = mr(",; \t"),
      wr = mr(/[^\n\r]/);

  function Sr(e, t) {
    if (!1 === t) return !1;
    if ("/" === e.charAt(t) && "*" === e.charAt(t + 1)) for (var _r5 = t + 2; _r5 < e.length; ++_r5) {
      if ("*" === e.charAt(_r5) && "/" === e.charAt(_r5 + 1)) return _r5 + 2;
    }
    return t;
  }

  function Ir(e, t) {
    return !1 !== t && ("/" === e.charAt(t) && "/" === e.charAt(t + 1) ? wr(e, t) : t);
  }

  function Or(e, t, r) {
    var n = r && r.backwards;
    if (!1 === t) return !1;
    var i = e.charAt(t);

    if (n) {
      if ("\r" === e.charAt(t - 1) && "\n" === i) return t - 2;
      if ("\n" === i || "\r" === i || "\u2028" === i || "\u2029" === i) return t - 1;
    } else {
      if ("\r" === i && "\n" === e.charAt(t + 1)) return t + 2;
      if ("\n" === i || "\r" === i || "\u2028" === i || "\u2029" === i) return t + 1;
    }

    return t;
  }

  function Nr(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var n = xr(e, r.backwards ? t - 1 : t, r);
    return n !== Or(e, n, r);
  }

  function br(e, t) {
    var r = null,
        n = t;

    for (; n !== r;) {
      r = n, n = Ar(e, n), n = Sr(e, n), n = xr(e, n);
    }

    return n = Ir(e, n), n = Or(e, n), !1 !== n && Nr(e, n);
  }

  function Br(e, t) {
    var r = null,
        n = t;

    for (; n !== r;) {
      r = n, n = xr(e, n), n = Sr(e, n), n = Ir(e, n), n = Or(e, n);
    }

    return n;
  }

  function Pr(e, t, r) {
    return Br(e, r(t));
  }

  function Tr(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var n = 0;

    for (var _i3 = r; _i3 < e.length; ++_i3) {
      "\t" === e[_i3] ? n = n + t - n % t : n++;
    }

    return n;
  }

  function Lr(e, t) {
    var r = e.slice(1, -1),
        n = {
      quote: '"',
      regex: /"/g
    },
        i = {
      quote: "'",
      regex: /'/g
    },
        s = "'" === t ? i : n,
        u = s === i ? n : i;
    var a = s.quote;

    if (r.includes(s.quote) || r.includes(u.quote)) {
      a = (r.match(s.regex) || []).length > (r.match(u.regex) || []).length ? u.quote : s.quote;
    }

    return a;
  }

  function Rr(e, t, r) {
    var n = '"' === t ? "'" : '"',
        i = e.replace(/\\([\s\S])|(["'])/g, function (e, i, s) {
      return i === n ? i : s === t ? "\\" + s : s || (r && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(i) ? i : "\\" + i);
    });
    return t + i + t;
  }

  function kr(e, t) {
    (e.comments || (e.comments = [])).push(t), t.printed = !1, t.nodeDescription = function (e) {
      var t = e.type || e.kind || "(unknown type)";
      var r = String(e.name || e.id && ("object" == typeof e.id ? e.id.name : e.id) || e.key && ("object" == typeof e.key ? e.key.name : e.key) || e.value && ("object" == typeof e.value ? "" : String(e.value)) || e.operator || "");
      r.length > 20 && (r = r.slice(0, 19) + "\u2026");
      return t + (r ? " " + r : "");
    }(e);
  }

  var $r = {
    inferParserByLanguage: function inferParserByLanguage(e, t) {
      var _Fr = Fr({
        plugins: t.plugins
      }),
          r = _Fr.languages,
          n = r.find(function (_ref6) {
        var t = _ref6.name;
        return t.toLowerCase() === e;
      }) || r.find(function (_ref7) {
        var t = _ref7.aliases;
        return Array.isArray(t) && t.includes(e);
      }) || r.find(function (_ref8) {
        var t = _ref8.extensions;
        return Array.isArray(t) && t.includes(".".concat(e));
      });

      return n && n.parsers[0];
    },
    getStringWidth: function getStringWidth(e) {
      return e ? gr.test(e) ? s(e) : e.length : 0;
    },
    getMaxContinuousCount: function getMaxContinuousCount(e, t) {
      var r = e.match(new RegExp("(".concat(a(t), ")+"), "g"));
      return null === r ? 0 : r.reduce(function (e, r) {
        return Math.max(e, r.length / t.length);
      }, 0);
    },
    getMinNotPresentContinuousCount: function getMinNotPresentContinuousCount(e, t) {
      var r = e.match(new RegExp("(".concat(a(t), ")+"), "g"));
      if (null === r) return 0;
      var n = new Map();
      var i = 0;

      var _iterator3 = _createForOfIteratorHelper(r),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _e6 = _step3.value;

          var _r6 = _e6.length / t.length;

          n.set(_r6, !0), _r6 > i && (i = _r6);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      for (var _e5 = 1; _e5 < i; _e5++) {
        if (!n.get(_e5)) return _e5;
      }

      return i + 1;
    },
    getPenultimate: function getPenultimate(e) {
      return e[e.length - 2];
    },
    getLast: o,
    getNextNonSpaceNonCommentCharacterIndexWithStartIndex: Br,
    getNextNonSpaceNonCommentCharacterIndex: Pr,
    getNextNonSpaceNonCommentCharacter: function getNextNonSpaceNonCommentCharacter(e, t, r) {
      return e.charAt(Pr(e, t, r));
    },
    skip: mr,
    skipWhitespace: yr,
    skipSpaces: xr,
    skipToLineEnd: Ar,
    skipEverythingButNewLine: wr,
    skipInlineComment: Sr,
    skipTrailingComment: Ir,
    skipNewline: Or,
    isNextLineEmptyAfterIndex: br,
    isNextLineEmpty: function isNextLineEmpty(e, t, r) {
      return br(e, r(t));
    },
    isPreviousLineEmpty: function isPreviousLineEmpty(e, t, r) {
      var n = r(t) - 1;
      return n = xr(e, n, {
        backwards: !0
      }), n = Or(e, n, {
        backwards: !0
      }), n = xr(e, n, {
        backwards: !0
      }), n !== Or(e, n, {
        backwards: !0
      });
    },
    hasNewline: Nr,
    hasNewlineInRange: function hasNewlineInRange(e, t, r) {
      for (var _n4 = t; _n4 < r; ++_n4) {
        if ("\n" === e.charAt(_n4)) return !0;
      }

      return !1;
    },
    hasSpaces: function hasSpaces(e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return xr(e, r.backwards ? t - 1 : t, r) !== t;
    },
    getAlignmentSize: Tr,
    getIndentSize: function getIndentSize(e, t) {
      var r = e.lastIndexOf("\n");
      return -1 === r ? 0 : Tr(e.slice(r + 1).match(/^[\t ]*/)[0], t);
    },
    getPreferredQuote: Lr,
    printString: function printString(e, t) {
      return Rr(e.slice(1, -1), "json" === t.parser || "json5" === t.parser && "preserve" === t.quoteProps && !t.singleQuote ? '"' : t.__isInHtmlAttribute ? "'" : Lr(e, t.singleQuote ? "'" : '"'), !("css" === t.parser || "less" === t.parser || "scss" === t.parser || t.__embeddedInHtml));
    },
    printNumber: function printNumber(e) {
      return e.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
    },
    makeString: Rr,
    addLeadingComment: function addLeadingComment(e, t) {
      t.leading = !0, t.trailing = !1, kr(e, t);
    },
    addDanglingComment: function addDanglingComment(e, t, r) {
      t.leading = !1, t.trailing = !1, r && (t.marker = r), kr(e, t);
    },
    addTrailingComment: function addTrailingComment(e, t) {
      t.leading = !1, t.trailing = !0, kr(e, t);
    },
    isFrontMatterNode: function isFrontMatterNode(e) {
      return e && "front-matter" === e.type;
    },
    getShebang: function getShebang(e) {
      if (!e.startsWith("#!")) return "";
      var t = e.indexOf("\n");
      return -1 === t ? e : e.slice(0, t);
    },
    isNonEmptyArray: function isNonEmptyArray(e) {
      return Array.isArray(e) && e.length > 0;
    },
    createGroupIdMapper: function createGroupIdMapper(e) {
      var t = new WeakMap();
      return function (r) {
        return t.has(r) || t.set(r, Symbol(e)), t.get(r);
      };
    }
  };
  var _r = $r.isNonEmptyArray;

  function Mr(e, t) {
    var _ref9 = t || {},
        r = _ref9.ignoreDecorators;

    if (!r) {
      var _t3 = e.declaration && e.declaration.decorators || e.decorators;

      if (_r(_t3)) return Mr(_t3[0]);
    }

    return e.range ? e.range[0] : e.start;
  }

  function jr(e) {
    return e.range ? e.range[1] : e.end;
  }

  function Gr(e, t) {
    return Mr(e) === Mr(t);
  }

  var Kr,
      Ur = {
    locStart: Mr,
    locEnd: jr,
    hasSameLocStart: Gr,
    hasSameLoc: function hasSameLoc(e, t) {
      return Gr(e, t) && function (e, t) {
        return jr(e) === jr(t);
      }(e, t);
    }
  },
      Wr = p(function (e, t) {
    var r = "\n",
        n = function () {
      function e(e) {
        this.string = e;

        for (var t = [0], n = 0; n < e.length;) {
          switch (e[n]) {
            case r:
              n += r.length, t.push(n);
              break;

            case "\r":
              e[n += "\r".length] === r && (n += r.length), t.push(n);
              break;

            default:
              n++;
          }
        }

        this.offsets = t;
      }

      return e.prototype.locationForIndex = function (e) {
        if (e < 0 || e > this.string.length) return null;

        for (var t = 0, r = this.offsets; r[t + 1] <= e;) {
          t++;
        }

        return {
          line: t,
          column: e - r[t]
        };
      }, e.prototype.indexForLocation = function (e) {
        var t = e.line,
            r = e.column;
        return t < 0 || t >= this.offsets.length || r < 0 || r > this.lengthOfLine(t) ? null : this.offsets[t] + r;
      }, e.prototype.lengthOfLine = function (e) {
        var t = this.offsets[e];
        return (e === this.offsets.length - 1 ? this.string.length : this.offsets[e + 1]) - t;
      }, e;
    }();

    t.__esModule = !0, t.default = n;
  }),
      Vr = p(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Context = void 0;

    t.Context = /*#__PURE__*/function () {
      function _class(e) {
        _classCallCheck(this, _class);

        this.text = e, this.locator = new r(this.text);
      }

      return _class;
    }();

    var r = /*#__PURE__*/function () {
      function r(e) {
        _classCallCheck(this, r);

        this._lineAndColumn = new Wr.default(e);
      }

      _createClass(r, [{
        key: "locationForIndex",
        value: function locationForIndex(e) {
          var _this$_lineAndColumn$ = this._lineAndColumn.locationForIndex(e),
              t = _this$_lineAndColumn$.line,
              _r7 = _this$_lineAndColumn$.column;

          return {
            line: t + 1,
            column: _r7
          };
        }
      }]);

      return r;
    }();
  });
  /**
  	 * @license
  	 * Copyright Google LLC All Rights Reserved.
  	 *
  	 * Use of this source code is governed by an MIT-style license that can be
  	 * found in the LICENSE file at https://angular.io/license
  	 */

  var Xr = function Xr(e, t, r, n) {
    _classCallCheck(this, Xr);

    this.input = t, this.errLocation = r, this.ctxLocation = n, this.message = "Parser Error: ".concat(e, " ").concat(r, " [").concat(t, "] in ").concat(n);
  };

  var zr = /*#__PURE__*/function () {
    function zr(e, t) {
      _classCallCheck(this, zr);

      this.start = e, this.end = t;
    }

    _createClass(zr, [{
      key: "toAbsolute",
      value: function toAbsolute(e) {
        return new gn(e + this.start, e + this.end);
      }
    }]);

    return zr;
  }();

  var qr = /*#__PURE__*/function () {
    function qr(e, t) {
      _classCallCheck(this, qr);

      this.span = e, this.sourceSpan = t;
    }

    _createClass(qr, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return null;
      }
    }, {
      key: "toString",
      value: function toString() {
        return "AST";
      }
    }]);

    return qr;
  }();

  var Qr = /*#__PURE__*/function (_qr) {
    _inherits(Qr, _qr);

    var _super = _createSuper(Qr);

    function Qr(e, t, r) {
      var _this;

      _classCallCheck(this, Qr);

      _this = _super.call(this, e, t), _this.nameSpan = r;
      return _this;
    }

    return Qr;
  }(qr);

  var Yr = /*#__PURE__*/function (_qr2) {
    _inherits(Yr, _qr2);

    var _super2 = _createSuper(Yr);

    function Yr(e, t, r, n, i) {
      var _this2;

      _classCallCheck(this, Yr);

      _this2 = _super2.call(this, e, t), _this2.prefix = r, _this2.uninterpretedExpression = n, _this2.location = i;
      return _this2;
    }

    _createClass(Yr, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitQuote(this, t);
      }
    }, {
      key: "toString",
      value: function toString() {
        return "Quote";
      }
    }]);

    return Yr;
  }(qr);

  var Hr = /*#__PURE__*/function (_qr3) {
    _inherits(Hr, _qr3);

    var _super3 = _createSuper(Hr);

    function Hr() {
      _classCallCheck(this, Hr);

      return _super3.apply(this, arguments);
    }

    _createClass(Hr, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      }
    }]);

    return Hr;
  }(qr);

  var Jr = /*#__PURE__*/function (_qr4) {
    _inherits(Jr, _qr4);

    var _super4 = _createSuper(Jr);

    function Jr() {
      _classCallCheck(this, Jr);

      return _super4.apply(this, arguments);
    }

    _createClass(Jr, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitImplicitReceiver(this, t);
      }
    }]);

    return Jr;
  }(qr);

  var Zr = /*#__PURE__*/function (_Jr) {
    _inherits(Zr, _Jr);

    var _super5 = _createSuper(Zr);

    function Zr() {
      _classCallCheck(this, Zr);

      return _super5.apply(this, arguments);
    }

    _createClass(Zr, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var r;
        return null === (r = e.visitThisReceiver) || void 0 === r ? void 0 : r.call(e, this, t);
      }
    }]);

    return Zr;
  }(Jr);

  var en = /*#__PURE__*/function (_qr5) {
    _inherits(en, _qr5);

    var _super6 = _createSuper(en);

    function en(e, t, r) {
      var _this3;

      _classCallCheck(this, en);

      _this3 = _super6.call(this, e, t), _this3.expressions = r;
      return _this3;
    }

    _createClass(en, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitChain(this, t);
      }
    }]);

    return en;
  }(qr);

  var tn = /*#__PURE__*/function (_qr6) {
    _inherits(tn, _qr6);

    var _super7 = _createSuper(tn);

    function tn(e, t, r, n, i) {
      var _this4;

      _classCallCheck(this, tn);

      _this4 = _super7.call(this, e, t), _this4.condition = r, _this4.trueExp = n, _this4.falseExp = i;
      return _this4;
    }

    _createClass(tn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitConditional(this, t);
      }
    }]);

    return tn;
  }(qr);

  var rn = /*#__PURE__*/function (_Qr) {
    _inherits(rn, _Qr);

    var _super8 = _createSuper(rn);

    function rn(e, t, r, n, i) {
      var _this5;

      _classCallCheck(this, rn);

      _this5 = _super8.call(this, e, t, r), _this5.receiver = n, _this5.name = i;
      return _this5;
    }

    _createClass(rn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitPropertyRead(this, t);
      }
    }]);

    return rn;
  }(Qr);

  var nn = /*#__PURE__*/function (_Qr2) {
    _inherits(nn, _Qr2);

    var _super9 = _createSuper(nn);

    function nn(e, t, r, n, i, s) {
      var _this6;

      _classCallCheck(this, nn);

      _this6 = _super9.call(this, e, t, r), _this6.receiver = n, _this6.name = i, _this6.value = s;
      return _this6;
    }

    _createClass(nn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitPropertyWrite(this, t);
      }
    }]);

    return nn;
  }(Qr);

  var sn = /*#__PURE__*/function (_Qr3) {
    _inherits(sn, _Qr3);

    var _super10 = _createSuper(sn);

    function sn(e, t, r, n, i) {
      var _this7;

      _classCallCheck(this, sn);

      _this7 = _super10.call(this, e, t, r), _this7.receiver = n, _this7.name = i;
      return _this7;
    }

    _createClass(sn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitSafePropertyRead(this, t);
      }
    }]);

    return sn;
  }(Qr);

  var un = /*#__PURE__*/function (_qr7) {
    _inherits(un, _qr7);

    var _super11 = _createSuper(un);

    function un(e, t, r, n) {
      var _this8;

      _classCallCheck(this, un);

      _this8 = _super11.call(this, e, t), _this8.obj = r, _this8.key = n;
      return _this8;
    }

    _createClass(un, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitKeyedRead(this, t);
      }
    }]);

    return un;
  }(qr);

  var an = /*#__PURE__*/function (_qr8) {
    _inherits(an, _qr8);

    var _super12 = _createSuper(an);

    function an(e, t, r, n, i) {
      var _this9;

      _classCallCheck(this, an);

      _this9 = _super12.call(this, e, t), _this9.obj = r, _this9.key = n, _this9.value = i;
      return _this9;
    }

    _createClass(an, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitKeyedWrite(this, t);
      }
    }]);

    return an;
  }(qr);

  var on = /*#__PURE__*/function (_Qr4) {
    _inherits(on, _Qr4);

    var _super13 = _createSuper(on);

    function on(e, t, r, n, i, s) {
      var _this10;

      _classCallCheck(this, on);

      _this10 = _super13.call(this, e, t, s), _this10.exp = r, _this10.name = n, _this10.args = i;
      return _this10;
    }

    _createClass(on, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitPipe(this, t);
      }
    }]);

    return on;
  }(Qr);

  var Dn = /*#__PURE__*/function (_qr9) {
    _inherits(Dn, _qr9);

    var _super14 = _createSuper(Dn);

    function Dn(e, t, r) {
      var _this11;

      _classCallCheck(this, Dn);

      _this11 = _super14.call(this, e, t), _this11.value = r;
      return _this11;
    }

    _createClass(Dn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitLiteralPrimitive(this, t);
      }
    }]);

    return Dn;
  }(qr);

  var cn = /*#__PURE__*/function (_qr10) {
    _inherits(cn, _qr10);

    var _super15 = _createSuper(cn);

    function cn(e, t, r) {
      var _this12;

      _classCallCheck(this, cn);

      _this12 = _super15.call(this, e, t), _this12.expressions = r;
      return _this12;
    }

    _createClass(cn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitLiteralArray(this, t);
      }
    }]);

    return cn;
  }(qr);

  var pn = /*#__PURE__*/function (_qr11) {
    _inherits(pn, _qr11);

    var _super16 = _createSuper(pn);

    function pn(e, t, r, n) {
      var _this13;

      _classCallCheck(this, pn);

      _this13 = _super16.call(this, e, t), _this13.keys = r, _this13.values = n;
      return _this13;
    }

    _createClass(pn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitLiteralMap(this, t);
      }
    }]);

    return pn;
  }(qr);

  var ln = /*#__PURE__*/function (_qr12) {
    _inherits(ln, _qr12);

    var _super17 = _createSuper(ln);

    function ln(e, t, r, n) {
      var _this14;

      _classCallCheck(this, ln);

      _this14 = _super17.call(this, e, t), _this14.strings = r, _this14.expressions = n;
      return _this14;
    }

    _createClass(ln, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitInterpolation(this, t);
      }
    }]);

    return ln;
  }(qr);

  var hn = /*#__PURE__*/function (_qr13) {
    _inherits(hn, _qr13);

    var _super18 = _createSuper(hn);

    function hn(e, t, r, n, i) {
      var _this15;

      _classCallCheck(this, hn);

      _this15 = _super18.call(this, e, t), _this15.operation = r, _this15.left = n, _this15.right = i;
      return _this15;
    }

    _createClass(hn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitBinary(this, t);
      }
    }]);

    return hn;
  }(qr);

  var dn = /*#__PURE__*/function (_hn) {
    _inherits(dn, _hn);

    var _super19 = _createSuper(dn);

    function dn(e, t, r, n, i, s, u) {
      var _this16;

      _classCallCheck(this, dn);

      _this16 = _super19.call(this, e, t, i, s, u), _this16.operator = r, _this16.expr = n;
      return _this16;
    }

    _createClass(dn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return void 0 !== e.visitUnary ? e.visitUnary(this, t) : e.visitBinary(this, t);
      }
    }], [{
      key: "createMinus",
      value: function createMinus(e, t, r) {
        return new dn(e, t, "-", r, "-", new Dn(e, t, 0), r);
      }
    }, {
      key: "createPlus",
      value: function createPlus(e, t, r) {
        return new dn(e, t, "+", r, "-", r, new Dn(e, t, 0));
      }
    }]);

    return dn;
  }(hn);

  var fn = /*#__PURE__*/function (_qr14) {
    _inherits(fn, _qr14);

    var _super20 = _createSuper(fn);

    function fn(e, t, r) {
      var _this17;

      _classCallCheck(this, fn);

      _this17 = _super20.call(this, e, t), _this17.expression = r;
      return _this17;
    }

    _createClass(fn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitPrefixNot(this, t);
      }
    }]);

    return fn;
  }(qr);

  var En = /*#__PURE__*/function (_qr15) {
    _inherits(En, _qr15);

    var _super21 = _createSuper(En);

    function En(e, t, r) {
      var _this18;

      _classCallCheck(this, En);

      _this18 = _super21.call(this, e, t), _this18.expression = r;
      return _this18;
    }

    _createClass(En, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitNonNullAssert(this, t);
      }
    }]);

    return En;
  }(qr);

  var Cn = /*#__PURE__*/function (_Qr5) {
    _inherits(Cn, _Qr5);

    var _super22 = _createSuper(Cn);

    function Cn(e, t, r, n, i, s, u) {
      var _this19;

      _classCallCheck(this, Cn);

      _this19 = _super22.call(this, e, t, r), _this19.receiver = n, _this19.name = i, _this19.args = s, _this19.argumentSpan = u;
      return _this19;
    }

    _createClass(Cn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitMethodCall(this, t);
      }
    }]);

    return Cn;
  }(Qr);

  var vn = /*#__PURE__*/function (_Qr6) {
    _inherits(vn, _Qr6);

    var _super23 = _createSuper(vn);

    function vn(e, t, r, n, i, s, u) {
      var _this20;

      _classCallCheck(this, vn);

      _this20 = _super23.call(this, e, t, r), _this20.receiver = n, _this20.name = i, _this20.args = s, _this20.argumentSpan = u;
      return _this20;
    }

    _createClass(vn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitSafeMethodCall(this, t);
      }
    }]);

    return vn;
  }(Qr);

  var Fn = /*#__PURE__*/function (_qr16) {
    _inherits(Fn, _qr16);

    var _super24 = _createSuper(Fn);

    function Fn(e, t, r, n) {
      var _this21;

      _classCallCheck(this, Fn);

      _this21 = _super24.call(this, e, t), _this21.target = r, _this21.args = n;
      return _this21;
    }

    _createClass(Fn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitFunctionCall(this, t);
      }
    }]);

    return Fn;
  }(qr);

  var gn = function gn(e, t) {
    _classCallCheck(this, gn);

    this.start = e, this.end = t;
  };

  var mn = /*#__PURE__*/function (_qr17) {
    _inherits(mn, _qr17);

    var _super25 = _createSuper(mn);

    function mn(e, t, r, n, i) {
      var _this22;

      _classCallCheck(this, mn);

      _this22 = _super25.call(this, new zr(0, null === t ? 0 : t.length), new gn(n, null === t ? n : n + t.length)), _this22.ast = e, _this22.source = t, _this22.location = r, _this22.errors = i;
      return _this22;
    }

    _createClass(mn, [{
      key: "visit",
      value: function visit(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return e.visitASTWithSource ? e.visitASTWithSource(this, t) : this.ast.visit(e, t);
      }
    }, {
      key: "toString",
      value: function toString() {
        return "".concat(this.source, " in ").concat(this.location);
      }
    }]);

    return mn;
  }(qr);

  var yn = function yn(e, t, r) {
    _classCallCheck(this, yn);

    this.sourceSpan = e, this.key = t, this.value = r;
  };

  var xn = function xn(e, t, r) {
    _classCallCheck(this, xn);

    this.sourceSpan = e, this.key = t, this.value = r;
  };

  var An = /*#__PURE__*/function () {
    function An() {
      _classCallCheck(this, An);
    }

    _createClass(An, [{
      key: "visit",
      value: function visit(e, t) {
        e.visit(this, t);
      }
    }, {
      key: "visitUnary",
      value: function visitUnary(e, t) {
        this.visit(e.expr, t);
      }
    }, {
      key: "visitBinary",
      value: function visitBinary(e, t) {
        this.visit(e.left, t), this.visit(e.right, t);
      }
    }, {
      key: "visitChain",
      value: function visitChain(e, t) {
        this.visitAll(e.expressions, t);
      }
    }, {
      key: "visitConditional",
      value: function visitConditional(e, t) {
        this.visit(e.condition, t), this.visit(e.trueExp, t), this.visit(e.falseExp, t);
      }
    }, {
      key: "visitPipe",
      value: function visitPipe(e, t) {
        this.visit(e.exp, t), this.visitAll(e.args, t);
      }
    }, {
      key: "visitFunctionCall",
      value: function visitFunctionCall(e, t) {
        e.target && this.visit(e.target, t), this.visitAll(e.args, t);
      }
    }, {
      key: "visitImplicitReceiver",
      value: function visitImplicitReceiver(e, t) {}
    }, {
      key: "visitThisReceiver",
      value: function visitThisReceiver(e, t) {}
    }, {
      key: "visitInterpolation",
      value: function visitInterpolation(e, t) {
        this.visitAll(e.expressions, t);
      }
    }, {
      key: "visitKeyedRead",
      value: function visitKeyedRead(e, t) {
        this.visit(e.obj, t), this.visit(e.key, t);
      }
    }, {
      key: "visitKeyedWrite",
      value: function visitKeyedWrite(e, t) {
        this.visit(e.obj, t), this.visit(e.key, t), this.visit(e.value, t);
      }
    }, {
      key: "visitLiteralArray",
      value: function visitLiteralArray(e, t) {
        this.visitAll(e.expressions, t);
      }
    }, {
      key: "visitLiteralMap",
      value: function visitLiteralMap(e, t) {
        this.visitAll(e.values, t);
      }
    }, {
      key: "visitLiteralPrimitive",
      value: function visitLiteralPrimitive(e, t) {}
    }, {
      key: "visitMethodCall",
      value: function visitMethodCall(e, t) {
        this.visit(e.receiver, t), this.visitAll(e.args, t);
      }
    }, {
      key: "visitPrefixNot",
      value: function visitPrefixNot(e, t) {
        this.visit(e.expression, t);
      }
    }, {
      key: "visitNonNullAssert",
      value: function visitNonNullAssert(e, t) {
        this.visit(e.expression, t);
      }
    }, {
      key: "visitPropertyRead",
      value: function visitPropertyRead(e, t) {
        this.visit(e.receiver, t);
      }
    }, {
      key: "visitPropertyWrite",
      value: function visitPropertyWrite(e, t) {
        this.visit(e.receiver, t), this.visit(e.value, t);
      }
    }, {
      key: "visitSafePropertyRead",
      value: function visitSafePropertyRead(e, t) {
        this.visit(e.receiver, t);
      }
    }, {
      key: "visitSafeMethodCall",
      value: function visitSafeMethodCall(e, t) {
        this.visit(e.receiver, t), this.visitAll(e.args, t);
      }
    }, {
      key: "visitQuote",
      value: function visitQuote(e, t) {}
    }, {
      key: "visitAll",
      value: function visitAll(e, t) {
        var _iterator4 = _createForOfIteratorHelper(e),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _r8 = _step4.value;
            this.visit(_r8, t);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }]);

    return An;
  }();

  !function (e) {
    e[e.DEFAULT = 0] = "DEFAULT", e[e.LITERAL_ATTR = 1] = "LITERAL_ATTR", e[e.ANIMATION = 2] = "ANIMATION";
  }(Kr || (Kr = {}));
  var wn = Object.freeze({
    __proto__: null,
    ParserError: Xr,
    ParseSpan: zr,
    AST: qr,
    ASTWithName: Qr,
    Quote: Yr,
    EmptyExpr: Hr,
    ImplicitReceiver: Jr,
    ThisReceiver: Zr,
    Chain: en,
    Conditional: tn,
    PropertyRead: rn,
    PropertyWrite: nn,
    SafePropertyRead: sn,
    KeyedRead: un,
    KeyedWrite: an,
    BindingPipe: on,
    LiteralPrimitive: Dn,
    LiteralArray: cn,
    LiteralMap: pn,
    Interpolation: ln,
    Binary: hn,
    Unary: dn,
    PrefixNot: fn,
    NonNullAssert: En,
    MethodCall: Cn,
    SafeMethodCall: vn,
    FunctionCall: Fn,
    AbsoluteSourceSpan: gn,
    ASTWithSource: mn,
    VariableBinding: yn,
    ExpressionBinding: xn,
    RecursiveAstVisitor: An,
    AstTransformer: /*#__PURE__*/function () {
      function AstTransformer() {
        _classCallCheck(this, AstTransformer);
      }

      _createClass(AstTransformer, [{
        key: "visitImplicitReceiver",
        value: function visitImplicitReceiver(e, t) {
          return e;
        }
      }, {
        key: "visitThisReceiver",
        value: function visitThisReceiver(e, t) {
          return e;
        }
      }, {
        key: "visitInterpolation",
        value: function visitInterpolation(e, t) {
          return new ln(e.span, e.sourceSpan, e.strings, this.visitAll(e.expressions));
        }
      }, {
        key: "visitLiteralPrimitive",
        value: function visitLiteralPrimitive(e, t) {
          return new Dn(e.span, e.sourceSpan, e.value);
        }
      }, {
        key: "visitPropertyRead",
        value: function visitPropertyRead(e, t) {
          return new rn(e.span, e.sourceSpan, e.nameSpan, e.receiver.visit(this), e.name);
        }
      }, {
        key: "visitPropertyWrite",
        value: function visitPropertyWrite(e, t) {
          return new nn(e.span, e.sourceSpan, e.nameSpan, e.receiver.visit(this), e.name, e.value.visit(this));
        }
      }, {
        key: "visitSafePropertyRead",
        value: function visitSafePropertyRead(e, t) {
          return new sn(e.span, e.sourceSpan, e.nameSpan, e.receiver.visit(this), e.name);
        }
      }, {
        key: "visitMethodCall",
        value: function visitMethodCall(e, t) {
          return new Cn(e.span, e.sourceSpan, e.nameSpan, e.receiver.visit(this), e.name, this.visitAll(e.args), e.argumentSpan);
        }
      }, {
        key: "visitSafeMethodCall",
        value: function visitSafeMethodCall(e, t) {
          return new vn(e.span, e.sourceSpan, e.nameSpan, e.receiver.visit(this), e.name, this.visitAll(e.args), e.argumentSpan);
        }
      }, {
        key: "visitFunctionCall",
        value: function visitFunctionCall(e, t) {
          return new Fn(e.span, e.sourceSpan, e.target.visit(this), this.visitAll(e.args));
        }
      }, {
        key: "visitLiteralArray",
        value: function visitLiteralArray(e, t) {
          return new cn(e.span, e.sourceSpan, this.visitAll(e.expressions));
        }
      }, {
        key: "visitLiteralMap",
        value: function visitLiteralMap(e, t) {
          return new pn(e.span, e.sourceSpan, e.keys, this.visitAll(e.values));
        }
      }, {
        key: "visitUnary",
        value: function visitUnary(e, t) {
          switch (e.operator) {
            case "+":
              return dn.createPlus(e.span, e.sourceSpan, e.expr.visit(this));

            case "-":
              return dn.createMinus(e.span, e.sourceSpan, e.expr.visit(this));

            default:
              throw new Error("Unknown unary operator ".concat(e.operator));
          }
        }
      }, {
        key: "visitBinary",
        value: function visitBinary(e, t) {
          return new hn(e.span, e.sourceSpan, e.operation, e.left.visit(this), e.right.visit(this));
        }
      }, {
        key: "visitPrefixNot",
        value: function visitPrefixNot(e, t) {
          return new fn(e.span, e.sourceSpan, e.expression.visit(this));
        }
      }, {
        key: "visitNonNullAssert",
        value: function visitNonNullAssert(e, t) {
          return new En(e.span, e.sourceSpan, e.expression.visit(this));
        }
      }, {
        key: "visitConditional",
        value: function visitConditional(e, t) {
          return new tn(e.span, e.sourceSpan, e.condition.visit(this), e.trueExp.visit(this), e.falseExp.visit(this));
        }
      }, {
        key: "visitPipe",
        value: function visitPipe(e, t) {
          return new on(e.span, e.sourceSpan, e.exp.visit(this), e.name, this.visitAll(e.args), e.nameSpan);
        }
      }, {
        key: "visitKeyedRead",
        value: function visitKeyedRead(e, t) {
          return new un(e.span, e.sourceSpan, e.obj.visit(this), e.key.visit(this));
        }
      }, {
        key: "visitKeyedWrite",
        value: function visitKeyedWrite(e, t) {
          return new an(e.span, e.sourceSpan, e.obj.visit(this), e.key.visit(this), e.value.visit(this));
        }
      }, {
        key: "visitAll",
        value: function visitAll(e) {
          var t = [];

          for (var _r9 = 0; _r9 < e.length; ++_r9) {
            t[_r9] = e[_r9].visit(this);
          }

          return t;
        }
      }, {
        key: "visitChain",
        value: function visitChain(e, t) {
          return new en(e.span, e.sourceSpan, this.visitAll(e.expressions));
        }
      }, {
        key: "visitQuote",
        value: function visitQuote(e, t) {
          return new Yr(e.span, e.sourceSpan, e.prefix, e.uninterpretedExpression, e.location);
        }
      }]);

      return AstTransformer;
    }(),
    AstMemoryEfficientTransformer: /*#__PURE__*/function () {
      function AstMemoryEfficientTransformer() {
        _classCallCheck(this, AstMemoryEfficientTransformer);
      }

      _createClass(AstMemoryEfficientTransformer, [{
        key: "visitImplicitReceiver",
        value: function visitImplicitReceiver(e, t) {
          return e;
        }
      }, {
        key: "visitThisReceiver",
        value: function visitThisReceiver(e, t) {
          return e;
        }
      }, {
        key: "visitInterpolation",
        value: function visitInterpolation(e, t) {
          var r = this.visitAll(e.expressions);
          return r !== e.expressions ? new ln(e.span, e.sourceSpan, e.strings, r) : e;
        }
      }, {
        key: "visitLiteralPrimitive",
        value: function visitLiteralPrimitive(e, t) {
          return e;
        }
      }, {
        key: "visitPropertyRead",
        value: function visitPropertyRead(e, t) {
          var r = e.receiver.visit(this);
          return r !== e.receiver ? new rn(e.span, e.sourceSpan, e.nameSpan, r, e.name) : e;
        }
      }, {
        key: "visitPropertyWrite",
        value: function visitPropertyWrite(e, t) {
          var r = e.receiver.visit(this),
              n = e.value.visit(this);
          return r !== e.receiver || n !== e.value ? new nn(e.span, e.sourceSpan, e.nameSpan, r, e.name, n) : e;
        }
      }, {
        key: "visitSafePropertyRead",
        value: function visitSafePropertyRead(e, t) {
          var r = e.receiver.visit(this);
          return r !== e.receiver ? new sn(e.span, e.sourceSpan, e.nameSpan, r, e.name) : e;
        }
      }, {
        key: "visitMethodCall",
        value: function visitMethodCall(e, t) {
          var r = e.receiver.visit(this),
              n = this.visitAll(e.args);
          return r !== e.receiver || n !== e.args ? new Cn(e.span, e.sourceSpan, e.nameSpan, r, e.name, n, e.argumentSpan) : e;
        }
      }, {
        key: "visitSafeMethodCall",
        value: function visitSafeMethodCall(e, t) {
          var r = e.receiver.visit(this),
              n = this.visitAll(e.args);
          return r !== e.receiver || n !== e.args ? new vn(e.span, e.sourceSpan, e.nameSpan, r, e.name, n, e.argumentSpan) : e;
        }
      }, {
        key: "visitFunctionCall",
        value: function visitFunctionCall(e, t) {
          var r = e.target && e.target.visit(this),
              n = this.visitAll(e.args);
          return r !== e.target || n !== e.args ? new Fn(e.span, e.sourceSpan, r, n) : e;
        }
      }, {
        key: "visitLiteralArray",
        value: function visitLiteralArray(e, t) {
          var r = this.visitAll(e.expressions);
          return r !== e.expressions ? new cn(e.span, e.sourceSpan, r) : e;
        }
      }, {
        key: "visitLiteralMap",
        value: function visitLiteralMap(e, t) {
          var r = this.visitAll(e.values);
          return r !== e.values ? new pn(e.span, e.sourceSpan, e.keys, r) : e;
        }
      }, {
        key: "visitUnary",
        value: function visitUnary(e, t) {
          var r = e.expr.visit(this);
          if (r !== e.expr) switch (e.operator) {
            case "+":
              return dn.createPlus(e.span, e.sourceSpan, r);

            case "-":
              return dn.createMinus(e.span, e.sourceSpan, r);

            default:
              throw new Error("Unknown unary operator ".concat(e.operator));
          }
          return e;
        }
      }, {
        key: "visitBinary",
        value: function visitBinary(e, t) {
          var r = e.left.visit(this),
              n = e.right.visit(this);
          return r !== e.left || n !== e.right ? new hn(e.span, e.sourceSpan, e.operation, r, n) : e;
        }
      }, {
        key: "visitPrefixNot",
        value: function visitPrefixNot(e, t) {
          var r = e.expression.visit(this);
          return r !== e.expression ? new fn(e.span, e.sourceSpan, r) : e;
        }
      }, {
        key: "visitNonNullAssert",
        value: function visitNonNullAssert(e, t) {
          var r = e.expression.visit(this);
          return r !== e.expression ? new En(e.span, e.sourceSpan, r) : e;
        }
      }, {
        key: "visitConditional",
        value: function visitConditional(e, t) {
          var r = e.condition.visit(this),
              n = e.trueExp.visit(this),
              i = e.falseExp.visit(this);
          return r !== e.condition || n !== e.trueExp || i !== e.falseExp ? new tn(e.span, e.sourceSpan, r, n, i) : e;
        }
      }, {
        key: "visitPipe",
        value: function visitPipe(e, t) {
          var r = e.exp.visit(this),
              n = this.visitAll(e.args);
          return r !== e.exp || n !== e.args ? new on(e.span, e.sourceSpan, r, e.name, n, e.nameSpan) : e;
        }
      }, {
        key: "visitKeyedRead",
        value: function visitKeyedRead(e, t) {
          var r = e.obj.visit(this),
              n = e.key.visit(this);
          return r !== e.obj || n !== e.key ? new un(e.span, e.sourceSpan, r, n) : e;
        }
      }, {
        key: "visitKeyedWrite",
        value: function visitKeyedWrite(e, t) {
          var r = e.obj.visit(this),
              n = e.key.visit(this),
              i = e.value.visit(this);
          return r !== e.obj || n !== e.key || i !== e.value ? new an(e.span, e.sourceSpan, r, n, i) : e;
        }
      }, {
        key: "visitAll",
        value: function visitAll(e) {
          var t = [];
          var r = !1;

          for (var _n5 = 0; _n5 < e.length; ++_n5) {
            var _i4 = e[_n5],
                _s2 = _i4.visit(this);

            t[_n5] = _s2, r = r || _s2 !== _i4;
          }

          return r ? t : e;
        }
      }, {
        key: "visitChain",
        value: function visitChain(e, t) {
          var r = this.visitAll(e.expressions);
          return r !== e.expressions ? new en(e.span, e.sourceSpan, r) : e;
        }
      }, {
        key: "visitQuote",
        value: function visitQuote(e, t) {
          return e;
        }
      }]);

      return AstMemoryEfficientTransformer;
    }(),
    ParsedProperty: function ParsedProperty(e, t, r, n, i, s) {
      _classCallCheck(this, ParsedProperty);

      this.name = e, this.expression = t, this.type = r, this.sourceSpan = n, this.keySpan = i, this.valueSpan = s, this.isLiteral = this.type === Kr.LITERAL_ATTR, this.isAnimation = this.type === Kr.ANIMATION;
    },

    get ParsedPropertyType() {
      return Kr;
    },

    ParsedEvent: function ParsedEvent(e, t, r, n, i, s, u) {
      _classCallCheck(this, ParsedEvent);

      this.name = e, this.targetOrPhase = t, this.type = r, this.handler = n, this.sourceSpan = i, this.handlerSpan = s, this.keySpan = u;
    },
    ParsedVariable: function ParsedVariable(e, t, r, n, i) {
      _classCallCheck(this, ParsedVariable);

      this.name = e, this.value = t, this.sourceSpan = r, this.keySpan = n, this.valueSpan = i;
    },
    BoundElementProperty: function BoundElementProperty(e, t, r, n, i, s, u, a) {
      _classCallCheck(this, BoundElementProperty);

      this.name = e, this.type = t, this.securityContext = r, this.value = n, this.unit = i, this.sourceSpan = s, this.keySpan = u, this.valueSpan = a;
    }
  });
  /**
  	 * @license
  	 * Copyright Google LLC All Rights Reserved.
  	 *
  	 * Use of this source code is governed by an MIT-style license that can be
  	 * found in the LICENSE file at https://angular.io/license
  	 */

  var Sn = 41,
      In = 46,
      On = 125;

  function Nn(e) {
    return 48 <= e && e <= 57;
  }
  /**
  	 * @license
  	 * Copyright Google LLC All Rights Reserved.
  	 *
  	 * Use of this source code is governed by an MIT-style license that can be
  	 * found in the LICENSE file at https://angular.io/license
  	 */


  var bn;
  !function (e) {
    e[e.Character = 0] = "Character", e[e.Identifier = 1] = "Identifier", e[e.PrivateIdentifier = 2] = "PrivateIdentifier", e[e.Keyword = 3] = "Keyword", e[e.String = 4] = "String", e[e.Operator = 5] = "Operator", e[e.Number = 6] = "Number", e[e.Error = 7] = "Error";
  }(bn || (bn = {}));
  var Bn = ["var", "let", "as", "null", "undefined", "true", "false", "if", "else", "this"];

  var Pn = /*#__PURE__*/function () {
    function Pn(e, t, r, n, i) {
      _classCallCheck(this, Pn);

      this.index = e, this.end = t, this.type = r, this.numValue = n, this.strValue = i;
    }

    _createClass(Pn, [{
      key: "isCharacter",
      value: function isCharacter(e) {
        return this.type == bn.Character && this.numValue == e;
      }
    }, {
      key: "isNumber",
      value: function isNumber() {
        return this.type == bn.Number;
      }
    }, {
      key: "isString",
      value: function isString() {
        return this.type == bn.String;
      }
    }, {
      key: "isOperator",
      value: function isOperator(e) {
        return this.type == bn.Operator && this.strValue == e;
      }
    }, {
      key: "isIdentifier",
      value: function isIdentifier() {
        return this.type == bn.Identifier;
      }
    }, {
      key: "isPrivateIdentifier",
      value: function isPrivateIdentifier() {
        return this.type == bn.PrivateIdentifier;
      }
    }, {
      key: "isKeyword",
      value: function isKeyword() {
        return this.type == bn.Keyword;
      }
    }, {
      key: "isKeywordLet",
      value: function isKeywordLet() {
        return this.type == bn.Keyword && "let" == this.strValue;
      }
    }, {
      key: "isKeywordAs",
      value: function isKeywordAs() {
        return this.type == bn.Keyword && "as" == this.strValue;
      }
    }, {
      key: "isKeywordNull",
      value: function isKeywordNull() {
        return this.type == bn.Keyword && "null" == this.strValue;
      }
    }, {
      key: "isKeywordUndefined",
      value: function isKeywordUndefined() {
        return this.type == bn.Keyword && "undefined" == this.strValue;
      }
    }, {
      key: "isKeywordTrue",
      value: function isKeywordTrue() {
        return this.type == bn.Keyword && "true" == this.strValue;
      }
    }, {
      key: "isKeywordFalse",
      value: function isKeywordFalse() {
        return this.type == bn.Keyword && "false" == this.strValue;
      }
    }, {
      key: "isKeywordThis",
      value: function isKeywordThis() {
        return this.type == bn.Keyword && "this" == this.strValue;
      }
    }, {
      key: "isError",
      value: function isError() {
        return this.type == bn.Error;
      }
    }, {
      key: "toNumber",
      value: function toNumber() {
        return this.type == bn.Number ? this.numValue : -1;
      }
    }, {
      key: "toString",
      value: function toString() {
        switch (this.type) {
          case bn.Character:
          case bn.Identifier:
          case bn.Keyword:
          case bn.Operator:
          case bn.PrivateIdentifier:
          case bn.String:
          case bn.Error:
            return this.strValue;

          case bn.Number:
            return this.numValue.toString();

          default:
            return null;
        }
      }
    }]);

    return Pn;
  }();

  function Tn(e, t, r) {
    return new Pn(e, t, bn.Character, r, String.fromCharCode(r));
  }

  function Ln(e, t, r) {
    return new Pn(e, t, bn.Operator, 0, r);
  }

  var Rn = new Pn(-1, -1, bn.Character, 0, "");

  var kn = /*#__PURE__*/function () {
    function kn(e) {
      _classCallCheck(this, kn);

      this.input = e, this.peek = 0, this.index = -1, this.length = e.length, this.advance();
    }

    _createClass(kn, [{
      key: "advance",
      value: function advance() {
        this.peek = ++this.index >= this.length ? 0 : this.input.charCodeAt(this.index);
      }
    }, {
      key: "scanToken",
      value: function scanToken() {
        var e = this.input,
            t = this.length;
        var r = this.peek,
            n = this.index;

        for (; r <= 32;) {
          if (++n >= t) {
            r = 0;
            break;
          }

          r = e.charCodeAt(n);
        }

        if (this.peek = r, this.index = n, n >= t) return null;
        if ($n(r)) return this.scanIdentifier();
        if (Nn(r)) return this.scanNumber(n);
        var i = n;

        switch (r) {
          case In:
            return this.advance(), Nn(this.peek) ? this.scanNumber(i) : Tn(i, this.index, In);

          case 40:
          case Sn:
          case 123:
          case On:
          case 91:
          case 93:
          case 44:
          case 58:
          case 59:
            return this.scanCharacter(i, r);

          case 39:
          case 34:
            return this.scanString();

          case 35:
            return this.scanPrivateIdentifier();

          case 43:
          case 45:
          case 42:
          case 47:
          case 37:
          case 94:
            return this.scanOperator(i, String.fromCharCode(r));

          case 63:
            return this.scanQuestion(i);

          case 60:
          case 62:
            return this.scanComplexOperator(i, String.fromCharCode(r), 61, "=");

          case 33:
          case 61:
            return this.scanComplexOperator(i, String.fromCharCode(r), 61, "=", 61, "=");

          case 38:
            return this.scanComplexOperator(i, "&", 38, "&");

          case 124:
            return this.scanComplexOperator(i, "|", 124, "|");

          case 160:
            for (; (s = this.peek) >= 9 && s <= 32 || 160 == s;) {
              this.advance();
            }

            return this.scanToken();
        }

        var s;
        return this.advance(), this.error("Unexpected character [".concat(String.fromCharCode(r), "]"), 0);
      }
    }, {
      key: "scanCharacter",
      value: function scanCharacter(e, t) {
        return this.advance(), Tn(e, this.index, t);
      }
    }, {
      key: "scanOperator",
      value: function scanOperator(e, t) {
        return this.advance(), Ln(e, this.index, t);
      }
    }, {
      key: "scanComplexOperator",
      value: function scanComplexOperator(e, t, r, n, i, s) {
        this.advance();
        var u = t;
        return this.peek == r && (this.advance(), u += n), null != i && this.peek == i && (this.advance(), u += s), Ln(e, this.index, u);
      }
    }, {
      key: "scanIdentifier",
      value: function scanIdentifier() {
        var e = this.index;

        for (this.advance(); Mn(this.peek);) {
          this.advance();
        }

        var t = this.input.substring(e, this.index);
        return Bn.indexOf(t) > -1 ? (r = e, n = this.index, i = t, new Pn(r, n, bn.Keyword, 0, i)) : function (e, t, r) {
          return new Pn(e, t, bn.Identifier, 0, r);
        }(e, this.index, t);
        var r, n, i;
      }
    }, {
      key: "scanPrivateIdentifier",
      value: function scanPrivateIdentifier() {
        var e = this.index;
        if (this.advance(), !$n(this.peek)) return this.error("Invalid character [#]", -1);

        for (; Mn(this.peek);) {
          this.advance();
        }

        var t = this.input.substring(e, this.index);
        return r = e, n = this.index, i = t, new Pn(r, n, bn.PrivateIdentifier, 0, i);
        var r, n, i;
      }
    }, {
      key: "scanNumber",
      value: function scanNumber(e) {
        var t = this.index === e;

        for (this.advance();;) {
          if (Nn(this.peek)) ;else if (this.peek == In) t = !1;else {
            if (101 != (r = this.peek) && 69 != r) break;
            if (this.advance(), jn(this.peek) && this.advance(), !Nn(this.peek)) return this.error("Invalid exponent", -1);
            t = !1;
          }
          this.advance();
        }

        var r;
        var n = this.input.substring(e, this.index),
            i = t ? function (e) {
          var t = parseInt(e);
          if (isNaN(t)) throw new Error("Invalid integer literal when parsing " + e);
          return t;
        }(n) : parseFloat(n);
        return s = e, u = this.index, a = i, new Pn(s, u, bn.Number, a, "");
        var s, u, a;
      }
    }, {
      key: "scanString",
      value: function scanString() {
        var e = this.index,
            t = this.peek;
        this.advance();
        var r = "",
            n = this.index;
        var i = this.input;

        for (; this.peek != t;) {
          if (92 == this.peek) {
            var _e7 = void 0;

            if (r += i.substring(n, this.index), this.advance(), this.peek = this.peek, 117 == this.peek) {
              var _t4 = i.substring(this.index + 1, this.index + 5);

              if (!/^[0-9a-f]+$/i.test(_t4)) return this.error("Invalid unicode escape [\\u".concat(_t4, "]"), 0);
              _e7 = parseInt(_t4, 16);

              for (var _e8 = 0; _e8 < 5; _e8++) {
                this.advance();
              }
            } else _e7 = Kn(this.peek), this.advance();

            r += String.fromCharCode(_e7), n = this.index;
          } else {
            if (0 == this.peek) return this.error("Unterminated quote", 0);
            this.advance();
          }
        }

        var s = i.substring(n, this.index);
        return this.advance(), u = e, a = this.index, o = r + s, new Pn(u, a, bn.String, 0, o);
        var u, a, o;
      }
    }, {
      key: "scanQuestion",
      value: function scanQuestion(e) {
        this.advance();
        var t = "?";
        return 63 !== this.peek && this.peek !== In || (t += this.peek === In ? "." : "?", this.advance()), Ln(e, this.index, t);
      }
    }, {
      key: "error",
      value: function error(e, t) {
        var r = this.index + t;
        return function (e, t, r) {
          return new Pn(e, t, bn.Error, 0, r);
        }(r, this.index, "Lexer Error: ".concat(e, " at column ").concat(r, " in expression [").concat(this.input, "]"));
      }
    }]);

    return kn;
  }();

  function $n(e) {
    return 97 <= e && e <= 122 || 65 <= e && e <= 90 || 95 == e || 36 == e;
  }

  function _n(e) {
    if (0 == e.length) return !1;
    var t = new kn(e);
    if (!$n(t.peek)) return !1;

    for (t.advance(); 0 !== t.peek;) {
      if (!Mn(t.peek)) return !1;
      t.advance();
    }

    return !0;
  }

  function Mn(e) {
    return function (e) {
      return e >= 97 && e <= 122 || e >= 65 && e <= 90;
    }(e) || Nn(e) || 95 == e || 36 == e;
  }

  function jn(e) {
    return 45 == e || 43 == e;
  }

  function Gn(e) {
    return 39 === e || 34 === e || 96 === e;
  }

  function Kn(e) {
    switch (e) {
      case 110:
        return 10;

      case 102:
        return 12;

      case 114:
        return 13;

      case 116:
        return 9;

      case 118:
        return 11;

      default:
        return e;
    }
  }

  var Un = Object.freeze({
    __proto__: null,

    get TokenType() {
      return bn;
    },

    Lexer: /*#__PURE__*/function () {
      function Lexer() {
        _classCallCheck(this, Lexer);
      }

      _createClass(Lexer, [{
        key: "tokenize",
        value: function tokenize(e) {
          var t = new kn(e),
              r = [];
          var n = t.scanToken();

          for (; null != n;) {
            r.push(n), n = t.scanToken();
          }

          return r;
        }
      }]);

      return Lexer;
    }(),
    Token: Pn,
    EOF: Rn,
    isIdentifier: _n,
    isQuote: Gn
  });
  /**
  	 * @license
  	 * Copyright Google LLC All Rights Reserved.
  	 *
  	 * Use of this source code is governed by an MIT-style license that can be
  	 * found in the LICENSE file at https://angular.io/license
  	 */

  var Wn = [/^\s*$/, /[<>]/, /^[{}]$/, /&(#|[a-z])/i, /^\/\//];
  /**
  	 * @license
  	 * Copyright Google LLC All Rights Reserved.
  	 *
  	 * Use of this source code is governed by an MIT-style license that can be
  	 * found in the LICENSE file at https://angular.io/license
  	 */

  var Vn = /*#__PURE__*/function () {
    function Vn(e, t) {
      _classCallCheck(this, Vn);

      this.start = e, this.end = t;
    }

    _createClass(Vn, null, [{
      key: "fromArray",
      value: function fromArray(e) {
        return e ? (function (e, t) {
          if (!(null == t || Array.isArray(t) && 2 == t.length)) throw new Error("Expected '".concat(e, "' to be an array, [start, end]."));

          if (null != t) {
            var _e9 = t[0],
                _r10 = t[1];
            Wn.forEach(function (t) {
              if (t.test(_e9) || t.test(_r10)) throw new Error("['".concat(_e9, "', '").concat(_r10, "'] contains unusable interpolation symbol."));
            });
          }
        }("interpolation", e), new Vn(e[0], e[1])) : Xn;
      }
    }]);

    return Vn;
  }();

  var Xn = new Vn("{{", "}}");
  /**
  	 * @license
  	 * Copyright Google LLC All Rights Reserved.
  	 *
  	 * Use of this source code is governed by an MIT-style license that can be
  	 * found in the LICENSE file at https://angular.io/license
  	 */

  var zn = function zn(e, t, r) {
    _classCallCheck(this, zn);

    this.strings = e, this.expressions = t, this.offsets = r;
  };

  var qn = function qn(e, t, r) {
    _classCallCheck(this, qn);

    this.templateBindings = e, this.warnings = t, this.errors = r;
  };

  var Qn = /*#__PURE__*/function () {
    function Qn(e) {
      _classCallCheck(this, Qn);

      this._lexer = e, this.errors = [], this.simpleExpressionChecker = Jn;
    }

    _createClass(Qn, [{
      key: "parseAction",
      value: function parseAction(e, t, r) {
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Xn;

        this._checkNoInterpolation(e, t, n);

        var i = this._stripComments(e),
            s = this._lexer.tokenize(this._stripComments(e)),
            u = new Hn(e, t, r, s, i.length, !0, this.errors, e.length - i.length).parseChain();

        return new mn(u, e, t, r, this.errors);
      }
    }, {
      key: "parseBinding",
      value: function parseBinding(e, t, r) {
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Xn;

        var i = this._parseBindingAst(e, t, r, n);

        return new mn(i, e, t, r, this.errors);
      }
    }, {
      key: "checkSimpleExpression",
      value: function checkSimpleExpression(e) {
        var t = new this.simpleExpressionChecker();
        return e.visit(t), t.errors;
      }
    }, {
      key: "parseSimpleBinding",
      value: function parseSimpleBinding(e, t, r) {
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Xn;

        var i = this._parseBindingAst(e, t, r, n),
            s = this.checkSimpleExpression(i);

        return s.length > 0 && this._reportError("Host binding expression cannot contain ".concat(s.join(" ")), e, t), new mn(i, e, t, r, this.errors);
      }
    }, {
      key: "_reportError",
      value: function _reportError(e, t, r, n) {
        this.errors.push(new Xr(e, t, r, n));
      }
    }, {
      key: "_parseBindingAst",
      value: function _parseBindingAst(e, t, r, n) {
        var i = this._parseQuote(e, t, r);

        if (null != i) return i;

        this._checkNoInterpolation(e, t, n);

        var s = this._stripComments(e),
            u = this._lexer.tokenize(s);

        return new Hn(e, t, r, u, s.length, !1, this.errors, e.length - s.length).parseChain();
      }
    }, {
      key: "_parseQuote",
      value: function _parseQuote(e, t, r) {
        if (null == e) return null;
        var n = e.indexOf(":");
        if (-1 == n) return null;
        var i = e.substring(0, n).trim();
        if (!_n(i)) return null;
        var s = e.substring(n + 1),
            u = new zr(0, e.length);
        return new Yr(u, u.toAbsolute(r), i, s, t);
      }
    }, {
      key: "parseTemplateBindings",
      value: function parseTemplateBindings(e, t, r, n, i) {
        var s = this._lexer.tokenize(t);

        return new Hn(t, r, i, s, t.length, !1, this.errors, 0).parseTemplateBindings({
          source: e,
          span: new gn(n, n + e.length)
        });
      }
    }, {
      key: "parseInterpolation",
      value: function parseInterpolation(e, t, r) {
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Xn;

        var _this$splitInterpolat = this.splitInterpolation(e, t, n),
            i = _this$splitInterpolat.strings,
            s = _this$splitInterpolat.expressions,
            u = _this$splitInterpolat.offsets;

        if (0 === s.length) return null;
        var a = [];

        for (var _n6 = 0; _n6 < s.length; ++_n6) {
          var _i5 = s[_n6].text,
              _o = this._stripComments(_i5),
              _D = this._lexer.tokenize(_o),
              _c = new Hn(e, t, r, _D, _o.length, !1, this.errors, u[_n6] + (_i5.length - _o.length)).parseChain();

          a.push(_c);
        }

        return this.createInterpolationAst(i.map(function (e) {
          return e.text;
        }), a, e, t, r);
      }
    }, {
      key: "parseInterpolationExpression",
      value: function parseInterpolationExpression(e, t, r) {
        var n = this._stripComments(e),
            i = this._lexer.tokenize(n),
            s = new Hn(e, t, r, i, n.length, !1, this.errors, 0).parseChain();

        return this.createInterpolationAst(["", ""], [s], e, t, r);
      }
    }, {
      key: "createInterpolationAst",
      value: function createInterpolationAst(e, t, r, n, i) {
        var s = new zr(0, r.length),
            u = new ln(s, s.toAbsolute(i), e, t);
        return new mn(u, r, n, i, this.errors);
      }
    }, {
      key: "splitInterpolation",
      value: function splitInterpolation(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Xn;
        var n = [],
            i = [],
            s = [];
        var u = 0,
            a = !1,
            o = !1,
            D = r.start,
            c = r.end;

        for (; u < e.length;) {
          if (a) {
            var _r11 = u,
                _n7 = _r11 + D.length,
                _p = this._getInterpolationEndIndex(e, c, _n7);

            if (-1 === _p) {
              a = !1, o = !0;
              break;
            }

            var _l = _p + c.length,
                _h = e.substring(_n7, _p);

            0 === _h.trim().length && this._reportError("Blank expressions are not allowed in interpolated strings", e, "at column ".concat(u, " in"), t), i.push({
              text: _h,
              start: _r11,
              end: _l
            }), s.push(_n7), u = _l, a = !1;
          } else {
            var _t5 = u;
            u = e.indexOf(D, u), -1 === u && (u = e.length);

            var _r12 = e.substring(_t5, u);

            n.push({
              text: _r12,
              start: _t5,
              end: u
            }), a = !0;
          }
        }

        if (!a) if (o) {
          var _t6 = n[n.length - 1];
          _t6.text += e.substring(u), _t6.end = e.length;
        } else n.push({
          text: e.substring(u),
          start: u,
          end: e.length
        });
        return new zn(n, i, s);
      }
    }, {
      key: "wrapLiteralPrimitive",
      value: function wrapLiteralPrimitive(e, t, r) {
        var n = new zr(0, null == e ? 0 : e.length);
        return new mn(new Dn(n, n.toAbsolute(r), e), e, t, r, this.errors);
      }
    }, {
      key: "_stripComments",
      value: function _stripComments(e) {
        var t = this._commentStart(e);

        return null != t ? e.substring(0, t).trim() : e;
      }
    }, {
      key: "_commentStart",
      value: function _commentStart(e) {
        var t = null;

        for (var _r13 = 0; _r13 < e.length - 1; _r13++) {
          var _n8 = e.charCodeAt(_r13),
              _i6 = e.charCodeAt(_r13 + 1);

          if (47 === _n8 && 47 == _i6 && null == t) return _r13;
          t === _n8 ? t = null : null == t && Gn(_n8) && (t = _n8);
        }

        return null;
      }
    }, {
      key: "_checkNoInterpolation",
      value: function _checkNoInterpolation(e, t, _ref10) {
        var r = _ref10.start,
            n = _ref10.end;
        var i = -1,
            s = -1;

        var _iterator5 = _createForOfIteratorHelper(this._forEachUnquotedChar(e, 0)),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _t7 = _step5.value;
            if (-1 === i) e.startsWith(r) && (i = _t7);else if (s = this._getInterpolationEndIndex(e, n, _t7), s > -1) break;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        i > -1 && s > -1 && this._reportError("Got interpolation (".concat(r).concat(n, ") where expression was expected"), e, "at column ".concat(i, " in"), t);
      }
    }, {
      key: "_getInterpolationEndIndex",
      value: function _getInterpolationEndIndex(e, t, r) {
        var _iterator6 = _createForOfIteratorHelper(this._forEachUnquotedChar(e, r)),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _n9 = _step6.value;
            if (e.startsWith(t, _n9)) return _n9;
            if (e.startsWith("//", _n9)) return e.indexOf(t, _n9);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        return -1;
      }
    }, {
      key: "_forEachUnquotedChar",
      value: /*#__PURE__*/_regeneratorRuntime.mark(function _forEachUnquotedChar(e, t) {
        var r, n, _i7, _t8;

        return _regeneratorRuntime.wrap(function _forEachUnquotedChar$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                r = null, n = 0;
                _i7 = t;

              case 2:
                if (!(_i7 < e.length)) {
                  _context.next = 16;
                  break;
                }

                _t8 = e[_i7];

                if (!(!Gn(e.charCodeAt(_i7)) || null !== r && r !== _t8 || n % 2 != 0)) {
                  _context.next = 11;
                  break;
                }

                _context.t0 = null === r;

                if (!_context.t0) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return _i7;

              case 9:
                _context.next = 12;
                break;

              case 11:
                r = null === r ? _t8 : null;

              case 12:
                n = "\\" === _t8 ? n + 1 : 0;

              case 13:
                _i7++;
                _context.next = 2;
                break;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _forEachUnquotedChar);
      })
    }]);

    return Qn;
  }();

  var Yn;
  !function (e) {
    e[e.None = 0] = "None", e[e.Writable = 1] = "Writable";
  }(Yn || (Yn = {}));

  var Hn = /*#__PURE__*/function () {
    function Hn(e, t, r, n, i, s, u, a) {
      _classCallCheck(this, Hn);

      this.input = e, this.location = t, this.absoluteOffset = r, this.tokens = n, this.inputLength = i, this.parseAction = s, this.errors = u, this.offset = a, this.rparensExpected = 0, this.rbracketsExpected = 0, this.rbracesExpected = 0, this.context = Yn.None, this.sourceSpanCache = new Map(), this.index = 0;
    }

    _createClass(Hn, [{
      key: "peek",
      value: function peek(e) {
        var t = this.index + e;
        return t < this.tokens.length ? this.tokens[t] : Rn;
      }
    }, {
      key: "next",
      get: function get() {
        return this.peek(0);
      }
    }, {
      key: "atEOF",
      get: function get() {
        return this.index >= this.tokens.length;
      }
    }, {
      key: "inputIndex",
      get: function get() {
        return this.atEOF ? this.currentEndIndex : this.next.index + this.offset;
      }
    }, {
      key: "currentEndIndex",
      get: function get() {
        if (this.index > 0) {
          return this.peek(-1).end + this.offset;
        }

        return 0 === this.tokens.length ? this.inputLength + this.offset : this.next.index + this.offset;
      }
    }, {
      key: "currentAbsoluteOffset",
      get: function get() {
        return this.absoluteOffset + this.inputIndex;
      }
    }, {
      key: "span",
      value: function span(e, t) {
        var r = this.currentEndIndex;

        if (void 0 !== t && t > this.currentEndIndex && (r = t), e > r) {
          var _t9 = r;
          r = e, e = _t9;
        }

        return new zr(e, r);
      }
    }, {
      key: "sourceSpan",
      value: function sourceSpan(e, t) {
        var r = "".concat(e, "@").concat(this.inputIndex, ":").concat(t);
        return this.sourceSpanCache.has(r) || this.sourceSpanCache.set(r, this.span(e, t).toAbsolute(this.absoluteOffset)), this.sourceSpanCache.get(r);
      }
    }, {
      key: "advance",
      value: function advance() {
        this.index++;
      }
    }, {
      key: "withContext",
      value: function withContext(e, t) {
        this.context |= e;
        var r = t();
        return this.context ^= e, r;
      }
    }, {
      key: "consumeOptionalCharacter",
      value: function consumeOptionalCharacter(e) {
        return !!this.next.isCharacter(e) && (this.advance(), !0);
      }
    }, {
      key: "peekKeywordLet",
      value: function peekKeywordLet() {
        return this.next.isKeywordLet();
      }
    }, {
      key: "peekKeywordAs",
      value: function peekKeywordAs() {
        return this.next.isKeywordAs();
      }
    }, {
      key: "expectCharacter",
      value: function expectCharacter(e) {
        this.consumeOptionalCharacter(e) || this.error("Missing expected ".concat(String.fromCharCode(e)));
      }
    }, {
      key: "consumeOptionalOperator",
      value: function consumeOptionalOperator(e) {
        return !!this.next.isOperator(e) && (this.advance(), !0);
      }
    }, {
      key: "expectOperator",
      value: function expectOperator(e) {
        this.consumeOptionalOperator(e) || this.error("Missing expected operator ".concat(e));
      }
    }, {
      key: "prettyPrintToken",
      value: function prettyPrintToken(e) {
        return e === Rn ? "end of input" : "token ".concat(e);
      }
    }, {
      key: "expectIdentifierOrKeyword",
      value: function expectIdentifierOrKeyword() {
        var e = this.next;
        return e.isIdentifier() || e.isKeyword() ? (this.advance(), e.toString()) : (e.isPrivateIdentifier() ? this._reportErrorForPrivateIdentifier(e, "expected identifier or keyword") : this.error("Unexpected ".concat(this.prettyPrintToken(e), ", expected identifier or keyword")), null);
      }
    }, {
      key: "expectIdentifierOrKeywordOrString",
      value: function expectIdentifierOrKeywordOrString() {
        var e = this.next;
        return e.isIdentifier() || e.isKeyword() || e.isString() ? (this.advance(), e.toString()) : (e.isPrivateIdentifier() ? this._reportErrorForPrivateIdentifier(e, "expected identifier, keyword or string") : this.error("Unexpected ".concat(this.prettyPrintToken(e), ", expected identifier, keyword, or string")), "");
      }
    }, {
      key: "parseChain",
      value: function parseChain() {
        var e = [],
            t = this.inputIndex;

        for (; this.index < this.tokens.length;) {
          var _t10 = this.parsePipe();

          if (e.push(_t10), this.consumeOptionalCharacter(59)) for (this.parseAction || this.error("Binding expression cannot contain chained expression"); this.consumeOptionalCharacter(59);) {
            ;
          } else this.index < this.tokens.length && this.error("Unexpected token '".concat(this.next, "'"));
        }

        if (0 == e.length) {
          var _e10 = this.offset,
              _t11 = this.offset + this.inputLength;

          return new Hr(this.span(_e10, _t11), this.sourceSpan(_e10, _t11));
        }

        return 1 == e.length ? e[0] : new en(this.span(t), this.sourceSpan(t), e);
      }
    }, {
      key: "parsePipe",
      value: function parsePipe() {
        var e = this.inputIndex;
        var t = this.parseExpression();

        if (this.consumeOptionalOperator("|")) {
          this.parseAction && this.error("Cannot have a pipe in an action expression");

          do {
            var _r14 = this.inputIndex;

            var _n10 = void 0,
                _i8 = void 0,
                _s3 = this.expectIdentifierOrKeyword();

            null !== _s3 ? _n10 = this.sourceSpan(_r14) : (_s3 = "", _i8 = -1 !== this.next.index ? this.next.index : this.inputLength + this.offset, _n10 = new zr(_i8, _i8).toAbsolute(this.absoluteOffset));
            var _u2 = [];

            for (; this.consumeOptionalCharacter(58);) {
              _u2.push(this.parseExpression());
            }

            t = new on(this.span(e), this.sourceSpan(e, _i8), t, _s3, _u2, _n10);
          } while (this.consumeOptionalOperator("|"));
        }

        return t;
      }
    }, {
      key: "parseExpression",
      value: function parseExpression() {
        return this.parseConditional();
      }
    }, {
      key: "parseConditional",
      value: function parseConditional() {
        var e = this.inputIndex,
            t = this.parseLogicalOr();

        if (this.consumeOptionalOperator("?")) {
          var _r15 = this.parsePipe();

          var _n11;

          if (this.consumeOptionalCharacter(58)) _n11 = this.parsePipe();else {
            var _t12 = this.inputIndex,
                _r16 = this.input.substring(e, _t12);

            this.error("Conditional expression ".concat(_r16, " requires all 3 expressions")), _n11 = new Hr(this.span(e), this.sourceSpan(e));
          }
          return new tn(this.span(e), this.sourceSpan(e), t, _r15, _n11);
        }

        return t;
      }
    }, {
      key: "parseLogicalOr",
      value: function parseLogicalOr() {
        var e = this.inputIndex;
        var t = this.parseLogicalAnd();

        for (; this.consumeOptionalOperator("||");) {
          var _r17 = this.parseLogicalAnd();

          t = new hn(this.span(e), this.sourceSpan(e), "||", t, _r17);
        }

        return t;
      }
    }, {
      key: "parseLogicalAnd",
      value: function parseLogicalAnd() {
        var e = this.inputIndex;
        var t = this.parseNullishCoalescing();

        for (; this.consumeOptionalOperator("&&");) {
          var _r18 = this.parseNullishCoalescing();

          t = new hn(this.span(e), this.sourceSpan(e), "&&", t, _r18);
        }

        return t;
      }
    }, {
      key: "parseNullishCoalescing",
      value: function parseNullishCoalescing() {
        var e = this.inputIndex;
        var t = this.parseEquality();

        for (; this.consumeOptionalOperator("??");) {
          var _r19 = this.parseEquality();

          t = new hn(this.span(e), this.sourceSpan(e), "??", t, _r19);
        }

        return t;
      }
    }, {
      key: "parseEquality",
      value: function parseEquality() {
        var e = this.inputIndex;
        var t = this.parseRelational();

        for (; this.next.type == bn.Operator;) {
          var _r20 = this.next.strValue;

          switch (_r20) {
            case "==":
            case "===":
            case "!=":
            case "!==":
              this.advance();

              var _n12 = this.parseRelational();

              t = new hn(this.span(e), this.sourceSpan(e), _r20, t, _n12);
              continue;
          }

          break;
        }

        return t;
      }
    }, {
      key: "parseRelational",
      value: function parseRelational() {
        var e = this.inputIndex;
        var t = this.parseAdditive();

        for (; this.next.type == bn.Operator;) {
          var _r21 = this.next.strValue;

          switch (_r21) {
            case "<":
            case ">":
            case "<=":
            case ">=":
              this.advance();

              var _n13 = this.parseAdditive();

              t = new hn(this.span(e), this.sourceSpan(e), _r21, t, _n13);
              continue;
          }

          break;
        }

        return t;
      }
    }, {
      key: "parseAdditive",
      value: function parseAdditive() {
        var e = this.inputIndex;
        var t = this.parseMultiplicative();

        for (; this.next.type == bn.Operator;) {
          var _r22 = this.next.strValue;

          switch (_r22) {
            case "+":
            case "-":
              this.advance();

              var _n14 = this.parseMultiplicative();

              t = new hn(this.span(e), this.sourceSpan(e), _r22, t, _n14);
              continue;
          }

          break;
        }

        return t;
      }
    }, {
      key: "parseMultiplicative",
      value: function parseMultiplicative() {
        var e = this.inputIndex;
        var t = this.parsePrefix();

        for (; this.next.type == bn.Operator;) {
          var _r23 = this.next.strValue;

          switch (_r23) {
            case "*":
            case "%":
            case "/":
              this.advance();

              var _n15 = this.parsePrefix();

              t = new hn(this.span(e), this.sourceSpan(e), _r23, t, _n15);
              continue;
          }

          break;
        }

        return t;
      }
    }, {
      key: "parsePrefix",
      value: function parsePrefix() {
        if (this.next.type == bn.Operator) {
          var _e11 = this.inputIndex;

          var _t13;

          switch (this.next.strValue) {
            case "+":
              return this.advance(), _t13 = this.parsePrefix(), dn.createPlus(this.span(_e11), this.sourceSpan(_e11), _t13);

            case "-":
              return this.advance(), _t13 = this.parsePrefix(), dn.createMinus(this.span(_e11), this.sourceSpan(_e11), _t13);

            case "!":
              return this.advance(), _t13 = this.parsePrefix(), new fn(this.span(_e11), this.sourceSpan(_e11), _t13);
          }
        }

        return this.parseCallChain();
      }
    }, {
      key: "parseCallChain",
      value: function parseCallChain() {
        var _this23 = this;

        var e = this.inputIndex;
        var t = this.parsePrimary();

        for (;;) {
          if (this.consumeOptionalCharacter(In)) t = this.parseAccessMemberOrMethodCall(t, e, !1);else if (this.consumeOptionalOperator("?.")) t = this.parseAccessMemberOrMethodCall(t, e, !0);else if (this.consumeOptionalCharacter(91)) this.withContext(Yn.Writable, function () {
            _this23.rbracketsExpected++;

            var r = _this23.parsePipe();

            if (r instanceof Hr && _this23.error("Key access cannot be empty"), _this23.rbracketsExpected--, _this23.expectCharacter(93), _this23.consumeOptionalOperator("=")) {
              var _n16 = _this23.parseConditional();

              t = new an(_this23.span(e), _this23.sourceSpan(e), t, r, _n16);
            } else t = new un(_this23.span(e), _this23.sourceSpan(e), t, r);
          });else if (this.consumeOptionalCharacter(40)) {
            this.rparensExpected++;

            var _r24 = this.parseCallArguments();

            this.rparensExpected--, this.expectCharacter(Sn), t = new Fn(this.span(e), this.sourceSpan(e), t, _r24);
          } else {
            if (!this.consumeOptionalOperator("!")) return t;
            t = new En(this.span(e), this.sourceSpan(e), t);
          }
        }
      }
    }, {
      key: "parsePrimary",
      value: function parsePrimary() {
        var e = this.inputIndex;

        if (this.consumeOptionalCharacter(40)) {
          this.rparensExpected++;

          var _e12 = this.parsePipe();

          return this.rparensExpected--, this.expectCharacter(Sn), _e12;
        }

        if (this.next.isKeywordNull()) return this.advance(), new Dn(this.span(e), this.sourceSpan(e), null);
        if (this.next.isKeywordUndefined()) return this.advance(), new Dn(this.span(e), this.sourceSpan(e), void 0);
        if (this.next.isKeywordTrue()) return this.advance(), new Dn(this.span(e), this.sourceSpan(e), !0);
        if (this.next.isKeywordFalse()) return this.advance(), new Dn(this.span(e), this.sourceSpan(e), !1);
        if (this.next.isKeywordThis()) return this.advance(), new Zr(this.span(e), this.sourceSpan(e));

        if (this.consumeOptionalCharacter(91)) {
          this.rbracketsExpected++;

          var _t14 = this.parseExpressionList(93);

          return this.rbracketsExpected--, this.expectCharacter(93), new cn(this.span(e), this.sourceSpan(e), _t14);
        }

        if (this.next.isCharacter(123)) return this.parseLiteralMap();
        if (this.next.isIdentifier()) return this.parseAccessMemberOrMethodCall(new Jr(this.span(e), this.sourceSpan(e)), e, !1);

        if (this.next.isNumber()) {
          var _t15 = this.next.toNumber();

          return this.advance(), new Dn(this.span(e), this.sourceSpan(e), _t15);
        }

        if (this.next.isString()) {
          var _t16 = this.next.toString();

          return this.advance(), new Dn(this.span(e), this.sourceSpan(e), _t16);
        }

        return this.next.isPrivateIdentifier() ? (this._reportErrorForPrivateIdentifier(this.next, null), new Hr(this.span(e), this.sourceSpan(e))) : this.index >= this.tokens.length ? (this.error("Unexpected end of expression: ".concat(this.input)), new Hr(this.span(e), this.sourceSpan(e))) : (this.error("Unexpected token ".concat(this.next)), new Hr(this.span(e), this.sourceSpan(e)));
      }
    }, {
      key: "parseExpressionList",
      value: function parseExpressionList(e) {
        var t = [];

        do {
          if (this.next.isCharacter(e)) break;
          t.push(this.parsePipe());
        } while (this.consumeOptionalCharacter(44));

        return t;
      }
    }, {
      key: "parseLiteralMap",
      value: function parseLiteralMap() {
        var e = [],
            t = [],
            r = this.inputIndex;

        if (this.expectCharacter(123), !this.consumeOptionalCharacter(On)) {
          this.rbracesExpected++;

          do {
            var _r25 = this.next.isString(),
                _n17 = this.expectIdentifierOrKeywordOrString();

            e.push({
              key: _n17,
              quoted: _r25
            }), this.expectCharacter(58), t.push(this.parsePipe());
          } while (this.consumeOptionalCharacter(44));

          this.rbracesExpected--, this.expectCharacter(On);
        }

        return new pn(this.span(r), this.sourceSpan(r), e, t);
      }
    }, {
      key: "parseAccessMemberOrMethodCall",
      value: function parseAccessMemberOrMethodCall(e, t) {
        var _this24 = this;

        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        var n = this.inputIndex,
            i = this.withContext(Yn.Writable, function () {
          var t;
          var r = null !== (t = _this24.expectIdentifierOrKeyword()) && void 0 !== t ? t : "";
          return 0 === r.length && _this24.error("Expected identifier for property access", e.span.end), r;
        }),
            s = this.sourceSpan(n);

        if (this.consumeOptionalCharacter(40)) {
          var _n18 = this.inputIndex;
          this.rparensExpected++;

          var _u3 = this.parseCallArguments(),
              _a = this.span(_n18, this.inputIndex).toAbsolute(this.absoluteOffset);

          this.expectCharacter(Sn), this.rparensExpected--;

          var _o2 = this.span(t),
              _D2 = this.sourceSpan(t);

          return r ? new vn(_o2, _D2, s, e, i, _u3, _a) : new Cn(_o2, _D2, s, e, i, _u3, _a);
        }

        if (r) return this.consumeOptionalOperator("=") ? (this.error("The '?.' operator cannot be used in the assignment"), new Hr(this.span(t), this.sourceSpan(t))) : new sn(this.span(t), this.sourceSpan(t), s, e, i);

        if (this.consumeOptionalOperator("=")) {
          if (!this.parseAction) return this.error("Bindings cannot contain assignments"), new Hr(this.span(t), this.sourceSpan(t));

          var _r26 = this.parseConditional();

          return new nn(this.span(t), this.sourceSpan(t), s, e, i, _r26);
        }

        return new rn(this.span(t), this.sourceSpan(t), s, e, i);
      }
    }, {
      key: "parseCallArguments",
      value: function parseCallArguments() {
        if (this.next.isCharacter(Sn)) return [];
        var e = [];

        do {
          e.push(this.parsePipe());
        } while (this.consumeOptionalCharacter(44));

        return e;
      }
    }, {
      key: "expectTemplateBindingKey",
      value: function expectTemplateBindingKey() {
        var e = "",
            t = !1;
        var r = this.currentAbsoluteOffset;

        do {
          e += this.expectIdentifierOrKeywordOrString(), t = this.consumeOptionalOperator("-"), t && (e += "-");
        } while (t);

        return {
          source: e,
          span: new gn(r, r + e.length)
        };
      }
    }, {
      key: "parseTemplateBindings",
      value: function parseTemplateBindings(e) {
        var t = [];

        for (t.push.apply(t, _toConsumableArray(this.parseDirectiveKeywordBindings(e))); this.index < this.tokens.length;) {
          var _r27 = this.parseLetBinding();

          if (_r27) t.push(_r27);else {
            var _r28 = this.expectTemplateBindingKey(),
                _n19 = this.parseAsBinding(_r28);

            _n19 ? t.push(_n19) : (_r28.source = e.source + _r28.source.charAt(0).toUpperCase() + _r28.source.substring(1), t.push.apply(t, _toConsumableArray(this.parseDirectiveKeywordBindings(_r28))));
          }
          this.consumeStatementTerminator();
        }

        return new qn(t, [], this.errors);
      }
    }, {
      key: "parseDirectiveKeywordBindings",
      value: function parseDirectiveKeywordBindings(e) {
        var t = [];
        this.consumeOptionalCharacter(58);
        var r = this.getDirectiveBoundTarget();
        var n = this.currentAbsoluteOffset;
        var i = this.parseAsBinding(e);
        i || (this.consumeStatementTerminator(), n = this.currentAbsoluteOffset);
        var s = new gn(e.span.start, n);
        return t.push(new xn(s, e, r)), i && t.push(i), t;
      }
    }, {
      key: "getDirectiveBoundTarget",
      value: function getDirectiveBoundTarget() {
        if (this.next === Rn || this.peekKeywordAs() || this.peekKeywordLet()) return null;
        var e = this.parsePipe(),
            _e$span = e.span,
            t = _e$span.start,
            r = _e$span.end,
            n = this.input.substring(t, r);
        return new mn(e, n, this.location, this.absoluteOffset + t, this.errors);
      }
    }, {
      key: "parseAsBinding",
      value: function parseAsBinding(e) {
        if (!this.peekKeywordAs()) return null;
        this.advance();
        var t = this.expectTemplateBindingKey();
        this.consumeStatementTerminator();
        var r = new gn(e.span.start, this.currentAbsoluteOffset);
        return new yn(r, t, e);
      }
    }, {
      key: "parseLetBinding",
      value: function parseLetBinding() {
        if (!this.peekKeywordLet()) return null;
        var e = this.currentAbsoluteOffset;
        this.advance();
        var t = this.expectTemplateBindingKey();
        var r = null;
        this.consumeOptionalOperator("=") && (r = this.expectTemplateBindingKey()), this.consumeStatementTerminator();
        var n = new gn(e, this.currentAbsoluteOffset);
        return new yn(n, t, r);
      }
    }, {
      key: "consumeStatementTerminator",
      value: function consumeStatementTerminator() {
        this.consumeOptionalCharacter(59) || this.consumeOptionalCharacter(44);
      }
    }, {
      key: "error",
      value: function error(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.errors.push(new Xr(e, this.input, this.locationText(t), this.location)), this.skip();
      }
    }, {
      key: "locationText",
      value: function locationText() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        return null == e && (e = this.index), e < this.tokens.length ? "at column ".concat(this.tokens[e].index + 1, " in") : "at the end of the expression";
      }
    }, {
      key: "_reportErrorForPrivateIdentifier",
      value: function _reportErrorForPrivateIdentifier(e, t) {
        var r = "Private identifiers are not supported. Unexpected private identifier: ".concat(e);
        null !== t && (r += ", ".concat(t)), this.error(r);
      }
    }, {
      key: "skip",
      value: function skip() {
        var e = this.next;

        for (; !(!(this.index < this.tokens.length) || e.isCharacter(59) || e.isOperator("|") || !(this.rparensExpected <= 0) && e.isCharacter(Sn) || !(this.rbracesExpected <= 0) && e.isCharacter(On) || !(this.rbracketsExpected <= 0) && e.isCharacter(93) || this.context & Yn.Writable && e.isOperator("="));) {
          this.next.isError() && this.errors.push(new Xr(this.next.toString(), this.input, this.locationText(), this.location)), this.advance(), e = this.next;
        }
      }
    }]);

    return Hn;
  }();

  var Jn = /*#__PURE__*/function () {
    function Jn() {
      _classCallCheck(this, Jn);

      this.errors = [];
    }

    _createClass(Jn, [{
      key: "visitImplicitReceiver",
      value: function visitImplicitReceiver(e, t) {}
    }, {
      key: "visitThisReceiver",
      value: function visitThisReceiver(e, t) {}
    }, {
      key: "visitInterpolation",
      value: function visitInterpolation(e, t) {}
    }, {
      key: "visitLiteralPrimitive",
      value: function visitLiteralPrimitive(e, t) {}
    }, {
      key: "visitPropertyRead",
      value: function visitPropertyRead(e, t) {}
    }, {
      key: "visitPropertyWrite",
      value: function visitPropertyWrite(e, t) {}
    }, {
      key: "visitSafePropertyRead",
      value: function visitSafePropertyRead(e, t) {}
    }, {
      key: "visitMethodCall",
      value: function visitMethodCall(e, t) {}
    }, {
      key: "visitSafeMethodCall",
      value: function visitSafeMethodCall(e, t) {}
    }, {
      key: "visitFunctionCall",
      value: function visitFunctionCall(e, t) {}
    }, {
      key: "visitLiteralArray",
      value: function visitLiteralArray(e, t) {
        this.visitAll(e.expressions, t);
      }
    }, {
      key: "visitLiteralMap",
      value: function visitLiteralMap(e, t) {
        this.visitAll(e.values, t);
      }
    }, {
      key: "visitUnary",
      value: function visitUnary(e, t) {}
    }, {
      key: "visitBinary",
      value: function visitBinary(e, t) {}
    }, {
      key: "visitPrefixNot",
      value: function visitPrefixNot(e, t) {}
    }, {
      key: "visitNonNullAssert",
      value: function visitNonNullAssert(e, t) {}
    }, {
      key: "visitConditional",
      value: function visitConditional(e, t) {}
    }, {
      key: "visitPipe",
      value: function visitPipe(e, t) {
        this.errors.push("pipes");
      }
    }, {
      key: "visitKeyedRead",
      value: function visitKeyedRead(e, t) {}
    }, {
      key: "visitKeyedWrite",
      value: function visitKeyedWrite(e, t) {}
    }, {
      key: "visitAll",
      value: function visitAll(e, t) {
        var _this25 = this;

        return e.map(function (e) {
          return e.visit(_this25, t);
        });
      }
    }, {
      key: "visitChain",
      value: function visitChain(e, t) {}
    }, {
      key: "visitQuote",
      value: function visitQuote(e, t) {}
    }]);

    return Jn;
  }();

  var Zn = /*#__PURE__*/function (_An) {
    _inherits(Zn, _An);

    var _super26 = _createSuper(Zn);

    function Zn() {
      var _this26;

      _classCallCheck(this, Zn);

      _this26 = _super26.apply(this, arguments), _this26.errors = [];
      return _this26;
    }

    _createClass(Zn, [{
      key: "visitPipe",
      value: function visitPipe() {
        this.errors.push("pipes");
      }
    }]);

    return Zn;
  }(An);

  var ei = Object.freeze({
    __proto__: null,
    SplitInterpolation: zn,
    TemplateBindingParseResult: qn,
    Parser: Qn,
    IvyParser: /*#__PURE__*/function (_Qn) {
      _inherits(IvyParser, _Qn);

      var _super27 = _createSuper(IvyParser);

      function IvyParser() {
        var _this27;

        _classCallCheck(this, IvyParser);

        _this27 = _super27.apply(this, arguments), _this27.simpleExpressionChecker = Zn;
        return _this27;
      }

      return IvyParser;
    }(Qn),
    _ParseAST: Hn
  }),
      ti = p(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getLast = t.toLowerCamelCase = t.findBackChar = t.findFrontChar = t.fitSpans = t.getNgType = t.parseNgInterpolation = t.parseNgTemplateBindings = t.parseNgAction = t.parseNgSimpleBinding = t.parseNgBinding = t.NG_PARSE_TEMPLATE_BINDINGS_FAKE_PREFIX = void 0;
    var r = "angular-estree-parser";
    t.NG_PARSE_TEMPLATE_BINDINGS_FAKE_PREFIX = "NgEstreeParser";
    var n = [r, 0];

    function i() {
      return new ei.Parser(new Un.Lexer());
    }

    function s(e, t) {
      var r = i(),
          _o3 = o(e, r),
          n = _o3.astInput,
          s = _o3.comments,
          _t17 = t(n, r),
          u = _t17.ast,
          D = _t17.errors;

      return a(D), {
        ast: u,
        comments: s
      };
    }

    function u(e, t) {
      if (e && "object" == typeof e) {
        if (Array.isArray(e)) return e.forEach(function (e) {
          return u(e, t);
        });

        for (var _i9 = 0, _Object$keys = Object.keys(e); _i9 < _Object$keys.length; _i9++) {
          var _r29 = _Object$keys[_i9];
          var _n20 = e[_r29];
          "span" === _r29 ? t(_n20) : u(_n20, t);
        }
      }
    }

    function a(e) {
      if (0 !== e.length) {
        var _e13 = _slicedToArray(e, 1),
            _t18 = _e13[0].message;

        throw new SyntaxError(_t18.replace(/^Parser Error: | at column \d+ in [^]*$/g, ""));
      }
    }

    function o(e, t) {
      var r = t._commentStart(e);

      return null === r ? {
        astInput: e,
        comments: []
      } : {
        astInput: e.slice(0, r),
        comments: [{
          type: "Comment",
          value: e.slice(r + "//".length),
          span: {
            start: r,
            end: e.length
          }
        }]
      };
    }

    function D(_ref11, r) {
      var e = _ref11.start,
          t = _ref11.end;
      var n = e,
          i = t;

      for (; i !== n && /\s/.test(r[i - 1]);) {
        i--;
      }

      for (; n !== i && /\s/.test(r[n]);) {
        n++;
      }

      return {
        start: n,
        end: i
      };
    }

    function c(_ref12, r) {
      var e = _ref12.start,
          t = _ref12.end;
      var n = e,
          i = t;

      for (; i !== r.length && /\s/.test(r[i]);) {
        i++;
      }

      for (; 0 !== n && /\s/.test(r[n - 1]);) {
        n--;
      }

      return {
        start: n,
        end: i
      };
    }

    function p(e, t) {
      return "(" === t[e.start - 1] && ")" === t[e.end] ? {
        start: e.start - 1,
        end: e.end + 1
      } : e;
    }

    t.parseNgBinding = function (e) {
      return s(e, function (e, t) {
        return t.parseBinding.apply(t, [e].concat(n));
      });
    }, t.parseNgSimpleBinding = function (e) {
      return s(e, function (e, t) {
        return t.parseSimpleBinding.apply(t, [e].concat(n));
      });
    }, t.parseNgAction = function (e) {
      return s(e, function (e, t) {
        return t.parseAction.apply(t, [e].concat(n));
      });
    }, t.parseNgTemplateBindings = function (e) {
      var n = i(),
          _n$parseTemplateBindi = n.parseTemplateBindings(t.NG_PARSE_TEMPLATE_BINDINGS_FAKE_PREFIX, e, r, 0, 0),
          s = _n$parseTemplateBindi.templateBindings,
          u = _n$parseTemplateBindi.errors;

      return a(u), s;
    }, t.parseNgInterpolation = function (e) {
      var t = i(),
          _o4 = o(e, t),
          r = _o4.astInput,
          s = _o4.comments,
          D = "{{",
          _t$parseInterpolation = t.parseInterpolation.apply(t, [D + r + "}}"].concat(n)),
          c = _t$parseInterpolation.ast,
          p = _t$parseInterpolation.errors;

      a(p);
      var l = c.expressions[0],
          h = new Set();
      return u(l, function (e) {
        h.has(e) || (e.start -= D.length, e.end -= D.length, h.add(e));
      }), {
        ast: l,
        comments: s
      };
    }, t.getNgType = function (e) {
      return wn.Unary && e instanceof wn.Unary ? "Unary" : e instanceof wn.Binary ? "Binary" : e instanceof wn.BindingPipe ? "BindingPipe" : e instanceof wn.Chain ? "Chain" : e instanceof wn.Conditional ? "Conditional" : e instanceof wn.EmptyExpr ? "EmptyExpr" : e instanceof wn.FunctionCall ? "FunctionCall" : e instanceof wn.ImplicitReceiver ? "ImplicitReceiver" : e instanceof wn.KeyedRead ? "KeyedRead" : e instanceof wn.KeyedWrite ? "KeyedWrite" : e instanceof wn.LiteralArray ? "LiteralArray" : e instanceof wn.LiteralMap ? "LiteralMap" : e instanceof wn.LiteralPrimitive ? "LiteralPrimitive" : e instanceof wn.MethodCall ? "MethodCall" : e instanceof wn.NonNullAssert ? "NonNullAssert" : e instanceof wn.PrefixNot ? "PrefixNot" : e instanceof wn.PropertyRead ? "PropertyRead" : e instanceof wn.PropertyWrite ? "PropertyWrite" : e instanceof wn.Quote ? "Quote" : e instanceof wn.SafeMethodCall ? "SafeMethodCall" : e instanceof wn.SafePropertyRead ? "SafePropertyRead" : e.type;
    }, t.fitSpans = function (e, t, r) {
      var n = 0;
      var i = {
        start: e.start,
        end: e.end
      };

      for (;;) {
        var _e14 = c(i, t),
            _r30 = p(_e14, t);

        if (_e14.start === _r30.start && _e14.end === _r30.end) break;
        i.start = _r30.start, i.end = _r30.end, n++;
      }

      return {
        hasParens: 0 !== (r ? n - 1 : n),
        outerSpan: D(r ? {
          start: i.start + 1,
          end: i.end - 1
        } : i, t),
        innerSpan: D(e, t)
      };
    }, t.findFrontChar = function (e, t, r) {
      var n = t;

      for (; !e.test(r[n]);) {
        if (--n < 0) throw new Error("Cannot find front char ".concat(e, " from index ").concat(t, " in ").concat(JSON.stringify(r)));
      }

      return n;
    }, t.findBackChar = function (e, t, r) {
      var n = t;

      for (; !e.test(r[n]);) {
        if (++n >= r.length) throw new Error("Cannot find back char ".concat(e, " from index ").concat(t, " in ").concat(JSON.stringify(r)));
      }

      return n;
    }, t.toLowerCamelCase = function (e) {
      return e.slice(0, 1).toLowerCase() + e.slice(1);
    }, t.getLast = function (e) {
      return 0 === e.length ? void 0 : e[e.length - 1];
    };
  }),
      ri = p(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.transformSpan = t.transform = void 0;

    function r(e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

      if (!r) {
        var _r31 = e.start,
            _n21 = e.end;
        return {
          start: _r31,
          end: _n21,
          loc: {
            start: t.locator.locationForIndex(_r31),
            end: t.locator.locationForIndex(_n21)
          }
        };
      }

      var _ti$fitSpans = ti.fitSpans(e, t.text, n),
          i = _ti$fitSpans.outerSpan,
          s = _ti$fitSpans.innerSpan,
          u = _ti$fitSpans.hasParens;

      return Object.assign({
        start: s.start,
        end: s.end,
        loc: {
          start: t.locator.locationForIndex(s.start),
          end: t.locator.locationForIndex(s.end)
        }
      }, u && {
        extra: {
          parenthesized: !0,
          parenStart: i.start,
          parenEnd: i.end
        }
      });
    }

    t.transform = function (e, n) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var s = ti.getNgType(e);

      switch (s) {
        case "Unary":
          {
            var _t19 = e.operator,
                _r32 = e.expr;
            return o("UnaryExpression", {
              prefix: !0,
              argument: u(_r32),
              operator: _t19
            }, e.span, {
              hasParentParens: i
            });
          }

        case "Binary":
          {
            var _t20 = e.left,
                _r33 = e.operation,
                _n22 = e.right,
                _s4 = _n22.span.start === _n22.span.end,
                _a2 = _t20.span.start === _t20.span.end;

            if (_s4 || _a2) {
              var _r34 = _t20.span.start === _t20.span.end ? u(_n22) : u(_t20);

              return o("UnaryExpression", {
                prefix: !0,
                argument: _r34,
                operator: _s4 ? "+" : "-"
              }, {
                start: e.span.start,
                end: E(_r34)
              }, {
                hasParentParens: i
              });
            }

            var _D3 = u(_t20),
                _c2 = u(_n22);

            return o("&&" === _r33 || "||" === _r33 ? "LogicalExpression" : "BinaryExpression", {
              left: _D3,
              right: _c2,
              operator: _r33
            }, {
              start: f(_D3),
              end: E(_c2)
            }, {
              hasParentParens: i
            });
          }

        case "BindingPipe":
          {
            var _t21 = e.exp,
                _r35 = e.name,
                _n23 = e.args,
                _s5 = u(_t21),
                _a3 = p(/\S/, p(/\|/, E(_s5)) + 1),
                _D4 = o("Identifier", {
              name: _r35
            }, {
              start: _a3,
              end: _a3 + _r35.length
            }),
                _c3 = _n23.map(u);

            return o("NGPipeExpression", {
              left: _s5,
              right: _D4,
              arguments: _c3
            }, {
              start: f(_s5),
              end: E(0 === _c3.length ? _D4 : ti.getLast(_c3))
            }, {
              hasParentParens: i
            });
          }

        case "Chain":
          {
            var _t22 = e.expressions;
            return o("NGChainedExpression", {
              expressions: _t22.map(u)
            }, e.span, {
              hasParentParens: i
            });
          }

        case "Comment":
          {
            var _t23 = e.value;
            return o("CommentLine", {
              value: _t23
            }, e.span, {
              processSpan: !1
            });
          }

        case "Conditional":
          {
            var _t24 = e.condition,
                _r36 = e.trueExp,
                _n24 = e.falseExp,
                _s6 = u(_t24),
                _a4 = u(_r36),
                _D5 = u(_n24);

            return o("ConditionalExpression", {
              test: _s6,
              consequent: _a4,
              alternate: _D5
            }, {
              start: f(_s6),
              end: E(_D5)
            }, {
              hasParentParens: i
            });
          }

        case "EmptyExpr":
          return o("NGEmptyExpression", {}, e.span, {
            hasParentParens: i
          });

        case "FunctionCall":
          {
            var _t25 = e.target,
                _r37 = e.args,
                _n25 = 1 === _r37.length ? [a(_r37[0])] : _r37.map(u),
                _s7 = u(_t25);

            return o("CallExpression", {
              callee: _s7,
              arguments: _n25
            }, {
              start: f(_s7),
              end: e.span.end
            }, {
              hasParentParens: i
            });
          }

        case "ImplicitReceiver":
          return o("ThisExpression", {}, e.span, {
            hasParentParens: i
          });

        case "KeyedRead":
          {
            var _t26 = e.obj,
                _r38 = e.key;
            return D(_t26, u(_r38), {
              computed: !0,
              optional: !1
            }, {
              end: e.span.end,
              hasParentParens: i
            });
          }

        case "LiteralArray":
          {
            var _t27 = e.expressions;
            return o("ArrayExpression", {
              elements: _t27.map(u)
            }, e.span, {
              hasParentParens: i
            });
          }

        case "LiteralMap":
          {
            var _t28 = e.keys,
                _r39 = e.values,
                _n26 = _r39.map(function (e) {
              return u(e);
            }),
                _s8 = _t28.map(function (_ref13, i) {
              var t = _ref13.key,
                  r = _ref13.quoted;
              var s = _n26[i],
                  u = {
                start: p(/\S/, 0 === i ? e.span.start + 1 : p(/,/, E(_n26[i - 1])) + 1),
                end: c(/\S/, c(/:/, f(s) - 1) - 1) + 1
              },
                  a = r ? o("StringLiteral", {
                value: t
              }, u) : o("Identifier", {
                name: t
              }, u);
              return o("ObjectProperty", {
                key: a,
                value: s,
                method: !1,
                shorthand: !1,
                computed: !1
              }, {
                start: f(a),
                end: E(s)
              });
            });

            return o("ObjectExpression", {
              properties: _s8
            }, e.span, {
              hasParentParens: i
            });
          }

        case "LiteralPrimitive":
          {
            var _t29 = e.value;

            switch (typeof _t29) {
              case "boolean":
                return o("BooleanLiteral", {
                  value: _t29
                }, e.span, {
                  hasParentParens: i
                });

              case "number":
                return o("NumericLiteral", {
                  value: _t29
                }, e.span, {
                  hasParentParens: i
                });

              case "object":
                return o("NullLiteral", {}, e.span, {
                  hasParentParens: i
                });

              case "string":
                return o("StringLiteral", {
                  value: _t29
                }, e.span, {
                  hasParentParens: i
                });

              case "undefined":
                return o("Identifier", {
                  name: "undefined"
                }, e.span, {
                  hasParentParens: i
                });

              default:
                throw new Error("Unexpected LiteralPrimitive value type " + typeof _t29);
            }
          }

        case "MethodCall":
        case "SafeMethodCall":
          {
            var _t30 = "SafeMethodCall" === s,
                _r40 = e.receiver,
                _n27 = e.name,
                _p2 = e.args,
                _l2 = 1 === _p2.length ? [a(_p2[0])] : _p2.map(u),
                _d = c(/\S/, c(/\(/, (0 === _l2.length ? c(/\)/, e.span.end - 1) : f(_l2[0])) - 1) - 1) + 1,
                _E = D(_r40, o("Identifier", {
              name: _n27
            }, {
              start: _d - _n27.length,
              end: _d
            }), {
              computed: !1,
              optional: _t30
            }),
                _C = h(_E);

            return o(_t30 || _C ? "OptionalCallExpression" : "CallExpression", {
              callee: _E,
              arguments: _l2
            }, {
              start: f(_E),
              end: e.span.end
            }, {
              hasParentParens: i
            });
          }

        case "NonNullAssert":
          {
            var _t31 = e.expression,
                _r41 = u(_t31);

            return o("TSNonNullExpression", {
              expression: _r41
            }, {
              start: f(_r41),
              end: e.span.end
            }, {
              hasParentParens: i
            });
          }

        case "PrefixNot":
          {
            var _t32 = e.expression,
                _r42 = u(_t32);

            return o("UnaryExpression", {
              prefix: !0,
              operator: "!",
              argument: _r42
            }, {
              start: e.span.start,
              end: E(_r42)
            }, {
              hasParentParens: i
            });
          }

        case "PropertyRead":
        case "SafePropertyRead":
          {
            var _t33 = "SafePropertyRead" === s,
                _r43 = e.receiver,
                _n28 = e.name,
                _u4 = c(/\S/, e.span.end - 1) + 1;

            return D(_r43, o("Identifier", {
              name: _n28
            }, {
              start: _u4 - _n28.length,
              end: _u4
            }, l(_r43) ? {
              hasParentParens: i
            } : {}), {
              computed: !1,
              optional: _t33
            }, {
              hasParentParens: i
            });
          }

        case "KeyedWrite":
          {
            var _t34 = e.obj,
                _r44 = e.key,
                _n29 = e.value,
                _s9 = u(_r44),
                _a5 = u(_n29),
                _c4 = D(_t34, _s9, {
              computed: !0,
              optional: !1
            }, {
              end: p(/\]/, E(_s9)) + 1
            });

            return o("AssignmentExpression", {
              left: _c4,
              operator: "=",
              right: _a5
            }, {
              start: f(_c4),
              end: E(_a5)
            }, {
              hasParentParens: i
            });
          }

        case "PropertyWrite":
          {
            var _t35 = e.receiver,
                _r45 = e.name,
                _n30 = e.value,
                _s10 = u(_n30),
                _a6 = c(/\S/, c(/=/, f(_s10) - 1) - 1) + 1,
                _p3 = D(_t35, o("Identifier", {
              name: _r45
            }, {
              start: _a6 - _r45.length,
              end: _a6
            }), {
              computed: !1,
              optional: !1
            });

            return o("AssignmentExpression", {
              left: _p3,
              operator: "=",
              right: _s10
            }, {
              start: f(_p3),
              end: E(_s10)
            }, {
              hasParentParens: i
            });
          }

        case "Quote":
          {
            var _t36 = e.prefix,
                _r46 = e.uninterpretedExpression;
            return o("NGQuotedExpression", {
              prefix: _t36,
              value: _r46
            }, e.span, {
              hasParentParens: i
            });
          }

        default:
          throw new Error("Unexpected node ".concat(s));
      }

      function u(e) {
        return t.transform(e, n);
      }

      function a(e) {
        return t.transform(e, n, !0);
      }

      function o(e, t, i) {
        var _ref14 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
            _ref14$processSpan = _ref14.processSpan,
            s = _ref14$processSpan === void 0 ? !0 : _ref14$processSpan,
            _ref14$hasParentParen = _ref14.hasParentParens,
            u = _ref14$hasParentParen === void 0 ? !1 : _ref14$hasParentParen;

        var a = Object.assign(Object.assign({
          type: e
        }, r(i, n, s, u)), t);

        switch (e) {
          case "Identifier":
            {
              var _e15 = a;
              _e15.loc.identifierName = _e15.name;
              break;
            }

          case "NumericLiteral":
            {
              var _e16 = a;
              _e16.extra = Object.assign(Object.assign({}, _e16.extra), {
                raw: n.text.slice(_e16.start, _e16.end),
                rawValue: _e16.value
              });
              break;
            }

          case "StringLiteral":
            {
              var _e17 = a;
              _e17.extra = Object.assign(Object.assign({}, _e17.extra), {
                raw: n.text.slice(_e17.start, _e17.end),
                rawValue: _e17.value
              });
              break;
            }
        }

        return a;
      }

      function D(e, t, r) {
        var _ref15 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
            _ref15$end = _ref15.end,
            n = _ref15$end === void 0 ? E(t) : _ref15$end,
            _ref15$hasParentParen = _ref15.hasParentParens,
            i = _ref15$hasParentParen === void 0 ? !1 : _ref15$hasParentParen;

        if (l(e)) return t;
        var s = u(e),
            a = h(s);
        return o(r.optional || a ? "OptionalMemberExpression" : "MemberExpression", Object.assign({
          object: s,
          property: t,
          computed: r.computed
        }, r.optional ? {
          optional: !0
        } : a ? {
          optional: !1
        } : null), {
          start: f(s),
          end: n
        }, {
          hasParentParens: i
        });
      }

      function c(e, t) {
        return ti.findFrontChar(e, t, n.text);
      }

      function p(e, t) {
        return ti.findBackChar(e, t, n.text);
      }

      function l(e) {
        return e.span.start >= e.span.end || /^\s+$/.test(n.text.slice(e.span.start, e.span.end));
      }

      function h(e) {
        return ("OptionalCallExpression" === e.type || "OptionalMemberExpression" === e.type) && !d(e);
      }

      function d(e) {
        return e.extra && e.extra.parenthesized;
      }

      function f(e) {
        return d(e) ? e.extra.parenStart : e.start;
      }

      function E(e) {
        return d(e) ? e.extra.parenEnd : e.end;
      }
    }, t.transformSpan = r;
  }),
      ni = p(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.transformTemplateBindings = void 0, t.transformTemplateBindings = function (e, t) {
      e.forEach(function (e) {
        h(e.key.span), l(e) && e.value && h(e.value.span);
      });

      var _e18 = _slicedToArray(e, 1),
          r = _e18[0],
          n = r.key,
          i = 0 === t.text.slice(r.sourceSpan.start, r.sourceSpan.end).trim().length ? e.slice(1) : e,
          s = [];

      var u = null;

      for (var _e19 = 0; _e19 < i.length; _e19++) {
        var _r47 = i[_e19];

        if (u && p(u) && l(_r47) && _r47.value && _r47.value.source === u.key.source) {
          (function () {
            var e = D("NGMicrosyntaxKey", {
              name: _r47.key.source
            }, _r47.key.span),
                n = function n(e, r) {
              return Object.assign(Object.assign({}, e), ri.transformSpan({
                start: e.start,
                end: r
              }, t));
            },
                i = function i(t) {
              return Object.assign(Object.assign({}, n(t, e.end)), {
                alias: e
              });
            },
                u = s.pop();

            if ("NGMicrosyntaxExpression" === u.type) s.push(i(u));else {
              if ("NGMicrosyntaxKeyedExpression" !== u.type) throw new Error("Unexpected type ".concat(u.type));
              {
                var _e20 = i(u.expression);

                s.push(n(Object.assign(Object.assign({}, u), {
                  expression: _e20
                }), _e20.end));
              }
            }
          })();
        } else s.push(a(_r47, _e19));

        u = _r47;
      }

      return D("NGMicrosyntax", {
        body: s
      }, 0 === s.length ? e[0].sourceSpan : {
        start: s[0].start,
        end: s[s.length - 1].end
      });

      function a(e, r) {
        if (p(e)) {
          var _t37 = e.key,
              _n31 = e.value;
          return _n31 ? 0 === r ? D("NGMicrosyntaxExpression", {
            expression: o(_n31.ast),
            alias: null
          }, _n31.sourceSpan) : D("NGMicrosyntaxKeyedExpression", {
            key: D("NGMicrosyntaxKey", {
              name: c(_t37.source)
            }, _t37.span),
            expression: D("NGMicrosyntaxExpression", {
              expression: o(_n31.ast),
              alias: null
            }, _n31.sourceSpan)
          }, {
            start: _t37.span.start,
            end: _n31.sourceSpan.end
          }) : D("NGMicrosyntaxKey", {
            name: c(_t37.source)
          }, _t37.span);
        }

        {
          var _r48 = e.key,
              _n32 = e.sourceSpan;

          if (/^let\s$/.test(t.text.slice(_n32.start, _n32.start + 4))) {
            var _t38 = e.value;
            return D("NGMicrosyntaxLet", {
              key: D("NGMicrosyntaxKey", {
                name: _r48.source
              }, _r48.span),
              value: _t38 ? D("NGMicrosyntaxKey", {
                name: _t38.source
              }, _t38.span) : null
            }, {
              start: _n32.start,
              end: _t38 ? _t38.span.end : _r48.span.end
            });
          }

          {
            var _n33 = function (e) {
              if (!e.value || e.value.source !== ti.NG_PARSE_TEMPLATE_BINDINGS_FAKE_PREFIX) return e.value;
              var r = ti.findBackChar(/\S/, e.sourceSpan.start, t.text);
              return {
                source: "$implicit",
                span: {
                  start: r,
                  end: r
                }
              };
            }(e);

            return D("NGMicrosyntaxAs", {
              key: D("NGMicrosyntaxKey", {
                name: _n33.source
              }, _n33.span),
              alias: D("NGMicrosyntaxKey", {
                name: _r48.source
              }, _r48.span)
            }, {
              start: _n33.span.start,
              end: _r48.span.end
            });
          }
        }
      }

      function o(e) {
        return ri.transform(e, t);
      }

      function D(e, r, n) {
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
        return Object.assign(Object.assign({
          type: e
        }, ri.transformSpan(n, t, i)), r);
      }

      function c(e) {
        return ti.toLowerCamelCase(e.slice(n.source.length));
      }

      function p(e) {
        return e instanceof wn.ExpressionBinding;
      }

      function l(e) {
        return e instanceof wn.VariableBinding;
      }

      function h(e) {
        if ('"' !== t.text[e.start] && "'" !== t.text[e.start]) return;
        var r = t.text[e.start];
        var n = !1;

        for (var _i10 = e.start + 1; _i10 < t.text.length; _i10++) {
          switch (t.text[_i10]) {
            case r:
              if (!n) return void (e.end = _i10 + 1);

            default:
              n = !1;
              break;

            case "\\":
              n = !n;
          }
        }
      }
    };
  }),
      ii = p(function (e, t) {
    function r(e, t) {
      var _t39 = t(e),
          r = _t39.ast,
          n = _t39.comments,
          i = new Vr.Context(e),
          s = function s(e) {
        return ri.transform(e, i);
      },
          u = s(r);

      return u.comments = n.map(s), u;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.parseTemplateBindings = t.parseAction = t.parseInterpolation = t.parseSimpleBinding = t.parseBinding = void 0, t.parseBinding = function (e) {
      return r(e, ti.parseNgBinding);
    }, t.parseSimpleBinding = function (e) {
      return r(e, ti.parseNgSimpleBinding);
    }, t.parseInterpolation = function (e) {
      return r(e, ti.parseNgInterpolation);
    }, t.parseAction = function (e) {
      return r(e, ti.parseNgAction);
    }, t.parseTemplateBindings = function (e) {
      return ni.transformTemplateBindings(ti.parseNgTemplateBindings(e), new Vr.Context(e));
    };
  });
  var si = Ur.locStart,
      ui = Ur.locEnd;

  function ai(e) {
    return {
      astFormat: "estree",
      parse: function parse(t, r, n) {
        var i = e(t, ii);
        return {
          type: "NGRoot",
          node: "__ng_action" === n.parser && "NGChainedExpression" !== i.type ? Object.assign(Object.assign({}, i), {}, {
            type: "NGChainedExpression",
            expressions: [i]
          }) : i
        };
      },
      locStart: si,
      locEnd: ui
    };
  }

  return {
    parsers: {
      __ng_action: ai(function (e, t) {
        return t.parseAction(e);
      }),
      __ng_binding: ai(function (e, t) {
        return t.parseBinding(e);
      }),
      __ng_interpolation: ai(function (e, t) {
        return t.parseInterpolation(e);
      }),
      __ng_directive: ai(function (e, t) {
        return t.parseTemplateBindings(e);
      })
    }
  };
});